// 公共与导航：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 公共基础词条
export const base = Object.freeze({
  "chatWorkbench.inboxChannels": "Contact channels",
  "chatWorkbench.personalContacts": "People",
  "chatWorkbench.receptionContacts": "Support",
  "chatWorkbench.selfChat": "Chat with myself",
  "chatWorkbench.selfChatHint": "Save thoughts, notes and to-dos",
  "chatWorkbench.pinConversation": "Pin",
  "chatWorkbench.unpinConversation": "Unpin",
  "chatWorkbench.pinnedConversation": "Pinned",
  "chatWorkbench.conversationMenuHint": "Right-click or press and hold for the conversation menu; keyboard: Shift+F10",
  "chatWorkbench.back": "Back",
  "chatWorkbench.expandSheet": "Expand chat",
  "chatWorkbench.restoreSheet": "Restore half screen",
  "chatWorkbench.agent.general": "Support Agent",
  "chatWorkbench.agent.product": "Product Agent",
  "chatWorkbench.agent.order": "Order support",
  "chatWorkbench.agent.supply_demand": "Supply-demand Agent",
  "chatWorkbench.resizeSheet": "Resize chat, currently {percent}%",
  "chatWorkbench.resizeSheetHint": "Drag the top handle to resize. Tap to cycle through 80%, 100%, 80%, and 50%. Up and Down arrow keys also adjust the size.",
  "clueDatasheet.notFound": "No datasheet found for this part number",
  "clueDatasheet.ambiguous": "Multiple brands match this part number. Please confirm the brand and try again.",
  "clueDatasheet.failed": "Unable to load the datasheet. Please try again later.",

  "chatWorkbench.title": "Messages",
  "chatWorkbench.pin": "Pin window across pages",
  "chatWorkbench.unpin": "Unpin and dock when navigating",
  "chatWorkbench.conversations": "Conversations",
  "chatWorkbench.hideConversations": "Hide conversations",

  "workflowChatAgent.title": "Read-only group assistant",
  "workflowChatAgent.progress": "Check progress",
  "workflowChatAgent.summary": "Summarize discussion",
  "workflowChatAgent.issues": "Identify issues",
  "workflowChatAgent.cancel": "Cancel task",
  "workflowChatAgent.rangeHint": "Uses up to 200 recent messages in this round and the current business snapshot.",
  "workflowChatAgent.failedHint": "This task did not complete. You can start a new request.",
  "workflowChatAgent.unavailable": "The assistant is unavailable. Please try again later.",
  "workflowChatAgent.messageEvidence": "Message evidence",
  "workflowChatAgent.businessEvidence": "Business snapshot",
  "workflowChatAgent.evidenceMissing": "This source is unavailable",
  "workflowChatAgent.status.READY": "Queued",
  "workflowChatAgent.status.RUNNING": "Processing",
  "workflowChatAgent.status.WAITING_RETRY": "Waiting to retry",
  "workflowChatAgent.status.SUCCEEDED": "Completed",
  "workflowChatAgent.status.FAILED": "Failed",
  "workflowChatAgent.status.CANCELLED": "Cancelled",
  "workflowChatAgent.status.DEAD_LETTER": "Retries exhausted",
  "devUpdates.googleContinue": "Continue with Google",
  "common.language": "Language",
  "common.chinese": "简体中文",
  "common.english": "English",
  "common.login": "Log in",
  "common.register": "Sign up",
  "common.logout": "Log out",
  "common.agentService": "Support",
  "common.wechat": "WeChat",
  "common.backToTop": "Back to top",
  "common.loading": "Loading...",
  "common.loginRequired": "Please log in first",
  "common.downloadFailed": "File download failed",
  "common.unauthorizedGoods":
    "You are not authorized to access the product library",
  "common.serverError": "Server error",
  "common.operationFailed": "Operation failed",
  "common.requestError": "Request failed. Please try again",
  "common.requestTimeout": "Request timed out. Check your connection",
  "common.searchPlaceholder": "Search part numbers or products",
  "common.searchAction": "Search",
  "nav.home": "Home",
  "nav.publish": "Publish",
  "nav.featured": "Featured",
  "nav.bidding": "Bidding",
  "nav.supply": "Supply & Demand",
  "nav.wiki": "Chip Wiki",
  "nav.trade": "Trade",
  "nav.ai": "XSOU AI",
  "nav.mine": "My XSOU",
  "nav.selfOperated": "Direct Sales",
  "nav.news": "News",
  "nav.priceChannel": "Market",
  "nav.brands": "Brands",
  "nav.bulkPublish": "Bulk Listing",
  "nav.featuredPublish": "Featured Products",
  "nav.mobileBulkPublish": "Bulk Listing",
  "nav.mobileFeaturedPublish": "Featured Listing",
  "nav.quickNavigation": "Quick navigation",
});

// 固定字段显示
// 本次 dev 合并新增的固定显示提示。
export const merged20261021 = Object.freeze({
  "devUpdates.oct23BulkPublish": "Publish bulk goods",
  "devUpdates.oct23GoogleSignUp": "Sign up with Google",
  "devUpdates.oct23GoogleSignIn": "Sign in with Google",
  "devUpdates.oct23ShippingRemarkRequired":
    "Enter shipping remarks if no file is uploaded",
  "devUpdates.oct23BuyerCommission": "Buyer commission",
  "devUpdates.oct23PaymentDetails": "Payment details",
  "devUpdates.oct23PaymentAmount": "Payment amount",
  "devUpdates.oct23CreditRepayment": "Credit repayment",
  "devUpdates.oct23CreditLimit": "Credit limit",
  "devUpdates.oct23LinkedBusinessNumber": "Linked business reference",
  "devUpdates.oct23SellerSourcePrice": "Seller source price",
  "devUpdates.oct23PriceHistory": "Price history",
  "devUpdates.oct23PreviousPrice": "Previous price",
  "devUpdates.oct23PreviousQuantity": "Previous quantity",
  "devUpdates.oct23Repay": "Repay",
  "devUpdates.oct23ShippingProofUploaded": "Shipping proof uploaded",
  "devUpdates.oct23ShippingProofFile": "Shipping proof file",
  "devUpdates.oct23ShippingRemark": "Shipping remarks",
  "devUpdates.oct23ShipmentDetails": "Shipment details",
  "devUpdates.oct23ChangedAmount": "Amount change",
  "devUpdates.oct23Agree": "Agree",
  "devUpdates.oct23No": "No",
  "devUpdates.oct23ClaimedGoodsEditHint":
    "A negotiator has claimed this product. Contact them to make changes",
  "devUpdates.oct23ProductTotal": "Product total",
  "devUpdates.oct23ProductTotalPrefix": "Product total: ",
  "devUpdates.oct23SplitProduct": "Split product order",
  "devUpdates.oct23SettleProduct": "Settle product",
  "devUpdates.oct23RecipientForm": "Enter delivery details",
  "devUpdates.oct23RemarkDescription": "Remarks",
  "devUpdates.oct23ReviewDecision": "Review decision",
  "devUpdates.oct23ReviewHistory": "Review history",
  "devUpdates.oct23WithdrawnAmount": "Amount withdrawn",
  "devUpdates.oct23ConfirmedPurchaseIntention": "Purchase intention confirmed",
  "devUpdates.oct23PlatformPassword": "Platform password",
  "devUpdates.oct23TotalPayable": "Total payable",
  "devUpdates.oct23Bank": "Bank",
  "devUpdates.oct23BankName": "Bank name",
  "devUpdates.oct23AvailableWithdrawalBalance": "Available withdrawal balance",
  "devUpdates.oct23BuyerRevisionPending": "Awaiting buyer revision",
  "devUpdates.oct23IntentionRevisionPending":
    "Purchase intention revision pending",
  "devUpdates.oct23IntentionConfirmationPending":
    "Purchase intention confirmation pending",
  "devUpdates.oct23SellerIntentionPending": "Awaiting seller confirmation",
  "devUpdates.oct23CreditOutstanding": "Outstanding credit balance",
  "devUpdates.oct23OptionalWechat": "WeChat ID (optional)",
  "devUpdates.oct23SplitQuantity": "Split quantity",
  "devUpdates.oct23Claim": "Claim",
  "devUpdates.oct23Claimed": "Claimed successfully",
  "devUpdates.oct23IdentityPhotoHint":
    "Submit a photo of your valid identity document",
  "devUpdates.oct23SubmitIntentionPrice": "Submit purchase intention price",
  "devUpdates.oct23WithdrawalReview": "Withdrawal review",
  "devUpdates.oct23WithdrawalHistory": "Withdrawal history",
  "devUpdates.oct23WithdrawalReference": "Withdrawal reference",
  "devUpdates.oct23WithdrawalStatus": "Withdrawal status",
  "devUpdates.oct23WithdrawalSubmitted": "Withdrawal request submitted",
  "devUpdates.oct23WithdrawalIdProofRequired":
    "Withdrawal ID missing. Payment proof cannot be submitted",
  "devUpdates.oct23WithdrawalIdReviewRequired":
    "Withdrawal ID missing. Review cannot be submitted",
  "devUpdates.oct23WithdrawalIdReceiptRequired":
    "Withdrawal ID missing. Receipt cannot be confirmed",
  "devUpdates.oct23WithdrawalDetails": "Withdrawal details",
  "devUpdates.oct23WithdrawalAmount": "Withdrawal amount",
  "devUpdates.oct23ExpenseHistory": "Expense history",
  "devUpdates.oct23ExpenseDetails": "Expense details",
  "devUpdates.oct23PayeeName": "Payee name",
  "devUpdates.oct23WholeOrderHint":
    "Submit the whole order without selecting specifications",
  "devUpdates.oct23Yes": "Yes",
  "devUpdates.oct23WholeOrder": "Whole order",
  "devUpdates.oct23NoProofOrRemark": "No proof or remarks",
  "devUpdates.oct23NoChildProducts": "No sub-product data",
  "devUpdates.oct23NoReviewHistory": "No review history",
  "devUpdates.oct23NoSpecifications": "No specification data",
  "devUpdates.oct23RecentWithdrawals":
    "Five latest withdrawal requests and their progress",
  "devUpdates.oct23SettlementHint":
    "Review linked orders and enter this settlement amount",
  "devUpdates.oct23Reference": "Reference",
  "devUpdates.oct23OverseasDocumentHint":
    "Overseas users may use a passport or government-issued identity document",
  "devUpdates.oct23CurrentPrice": "Current price",
  "devUpdates.oct23ContractPrice": "Contract generation price",
  "devUpdates.oct23RequestWithdrawal": "Request withdrawal",
  "devUpdates.oct23SupervisorInspector": "Supervisor and inspector",
  "devUpdates.oct23ConfirmClaim": "Confirm claim",
  "devUpdates.oct23ConfirmIntentionPrice": "Confirm intention price",
  "devUpdates.oct23ReceiptConfirmed": "Receipt confirmed",
  "devUpdates.oct23ConfirmRepayment": "Confirm repayment",
  "devUpdates.oct23Settle": "Settle",
  "devUpdates.oct23Settled": "Settled successfully",
  "devUpdates.oct23SettlementAmount": "Settlement amount",
  "devUpdates.oct23SettlementExceedsTotal":
    "Settlement amount cannot exceed the product total",
  "devUpdates.oct23ProductIdRequired":
    "Product ID missing. Linked orders cannot be queried",
  "devUpdates.oct23VerificationRegion": "Verification region",
  "devUpdates.oct23SplitWholeOrderUnavailable":
    "This product has been split and cannot be submitted as a whole order",
  "devUpdates.oct23GoogleBindingHint":
    "This email already has a platform account. Enter its platform password to link Google.",
  "devUpdates.oct23ShippingProofOrRemarkRequired":
    "Upload shipping proof or enter shipping remarks",
  "devUpdates.oct23IdentityPhotoRequired": "Upload an identity document photo",
  "devUpdates.oct23IdentityBackRequired":
    "Upload the emblem side of your identity card",
  "devUpdates.oct23PurchaseOrderRequired": "Complete the purchase order first",
  "devUpdates.oct23ConfirmWithdrawalReceipt":
    "Confirm that the withdrawal has arrived. Its status will then be marked as received.",
  "devUpdates.oct23ContactNegotiator": "Contact the negotiator to make changes",
  "devUpdates.oct23EnterSwiftCode": "Enter SWIFT code",
  "devUpdates.oct23EnterBuyerMobile": "Enter buyer mobile number",
  "devUpdates.oct23EnterProductTotal": "Enter product total",
  "devUpdates.oct23RepaymentMinimum":
    "Enter a repayment amount greater than 100",
  "devUpdates.oct23EnterBankName": "Enter bank name",
  "devUpdates.oct23EnterWithdrawalAmount": "Enter withdrawal amount",
  "devUpdates.oct23EnterPayeeName": "Enter payee name",
  "devUpdates.oct23EnterRecipientAddress": "Enter delivery address",
  "devUpdates.oct23EnterRecipientPhone": "Enter recipient phone number",
  "devUpdates.oct23EnterOwnMobile": "Enter your usual mobile number",
  "devUpdates.oct23EnterOwnEmail": "Enter your usual email address",
  "devUpdates.oct23InvalidSettlement": "Enter a valid settlement amount",
  "devUpdates.oct23EnterCurrentPrice": "Enter current price",
  "devUpdates.oct23EnterSettlement": "Enter settlement amount",
  "devUpdates.oct23BalanceHistoryHint":
    "Account balance changes and cash flow history",
  "devUpdates.oct23SellerCommission": "Seller commission",
  "devUpdates.oct23FundDirection": "Fund direction",
  "devUpdates.oct23FollowDetails": "Follow-up details",
  "devUpdates.oct23TransferProof": "Transfer proof",
  "devUpdates.oct23Repaid": "Repayment successful",
  "devUpdates.oct23RepaymentAmount": "Repayment amount",
  "devUpdates.oct23SelectWithdrawalCurrency": "Select withdrawal currency",
  "devUpdates.oct23SelectSettlementUnit": "Select settlement currency unit",
  "devUpdates.oct23ReconnectGoogle": "Reconnect Google",
  "devUpdates.oct23AmountType": "Amount type",
  "devUpdates.oct23VerifyExistingAccount": "Verify existing platform account",
  "devUpdates.oct23VerifyAndSignIn": "Verify and sign in",
  "devUpdates.oct23ProofFormatsHint":
    "(Images and videos supported; provide at least a file or remarks)",
  "devUpdates.oct23PurchaseOrderIncomplete": "(Purchase order incomplete)",
  "devUpdates.oct23GoogleVerifying": "Verifying Google account…",
  "devUpdates.oct23GoogleConnecting": "Connecting to Google…",
  "devUpdates.oct23GoogleVerifyingShort": "Verifying Google account",
  "devUpdates.oct23GoogleConnectingShort": "Connecting to Google",
  "devUpdates.oct23GoogleConfigUnavailable":
    "Google sign-in configuration is unavailable",
  "devUpdates.oct23GoogleInitializationFailed":
    "Google sign-in initialization failed",
  "devUpdates.oct23GoogleLoginFailed": "Google sign-in failed. Try again",
  "devUpdates.oct23ClaimFailed": "Claim failed",
  "devUpdates.oct23ClaimRetry": "Claim failed. Try again later",
  "devUpdates.oct23OwnMobile": "own mobile number",
  "devUpdates.oct23VerifyIdentityInstructions":
    "Verify your {method} and upload a valid identity document. Ensure the details match your document.",
  "devUpdates.oct23IdentityVerificationCompletion":
    "Identity verification completes after your {method} is verified",
  "devUpdates.oct23DocumentPage": "Identity document details page",
  "devUpdates.oct23DocumentPageHint":
    "The side showing your name, photo and document number",
  "devUpdates.oct23UploadDocumentPage": "Upload document details page",
  "devUpdates.oct23OptionalDocumentBack": "Document reverse (optional)",
  "devUpdates.oct23DocumentBackHint":
    "Upload the reverse if it contains information",
  "devUpdates.oct23UploadDocumentBack": "Upload document reverse",
  "devUpdates.oct23DocumentNumber": "Document number",
  "devUpdates.oct23EnterOverseasDocument":
    "Enter a passport or local identity document number",
  "devUpdates.oct23EnterEmailCode": "Enter the 4-digit email verification code",
  "devUpdates.oct23EmailCodeRequired":
    "Enter the 4-digit email verification code",
  "devUpdates.oct23SmsCodeRequired":
    "Enter a 4 to 6-digit SMS verification code",
  "devUpdates.oct23VerificationDocumentInvalid":
    "Enter a valid document number",
  "devUpdates.oct23MobileInvalid": "Enter a valid mobile number",
  "devUpdates.oct23EmailInvalid": "Enter a valid email address",
  "devUpdates.oct23BackOptional": "Reverse side optional",
  "devUpdates.oct23EmailSent": "Email sent. Check your inbox",
  "devUpdates.oct23SmsSent": "SMS sent. Check your messages",
  "devUpdates.oct23WithdrawalUnderReview": "Withdrawal under review",
  "devUpdates.oct23NormalAmount": "Available funds",
  "devUpdates.oct23UnknownBusiness": "Unknown business",
  "devUpdates.oct23UnknownDirection": "Unknown direction",
  "devUpdates.oct23ProductSale": "Product sale",
  "devUpdates.oct23SelfDeposit": "Top-up",
  "devUpdates.oct23SystemGrant": "System grant",
  "devUpdates.oct23ProductPurchase": "Product purchase",
  "devUpdates.oct23BalanceWithdrawal": "Balance withdrawal",
  "devUpdates.oct23SelectReview": "Select a review decision",
  "devUpdates.oct23EnterRepayment": "Enter repayment amount",
  "devUpdates.oct23SelectWithdrawalCurrencyRequired":
    "Select withdrawal currency",
  "devUpdates.oct23FileUploading": "Uploading files",
  "devUpdates.shippingManagement": "Shipment management",
  "devUpdates.createdBankSelectionRequired":
    "Bank created, but the new bank could not be identified. Change banks to select it.",
  "shipping.title": "Order shipment",
  "shipping.supplierIntro": "Enter shipment quantities for order items and delivery details",
  "shipping.completed": "Shipment completed",
  "shipping.intro":
    "Select warehouse receipts and outbound orders, then enter batch quantities and shipping details.",
  "shipping.orderQuantity": "Order quantity",
  "shipping.sentQuantity": "Shipped quantity",
  "shipping.remainingQuantity": "Quantity to ship",
  "shipping.historicalWarning":
    "This order has shipping history. Check the quantities already shipped.",
  "shipping.batchTitle": "Shipment batch {sequence}",
  "shipping.pending": "Awaiting shipment",
  "shipping.partial": "Partially shipped",
  "shipping.complete": "Fully shipped",
  "shipping.shipped": "Shipped",
  "shipping.deleteDraft": "Delete draft",
  "shipping.addWarehouse": "Add warehouse receipt",
  "shipping.deleteRow": "Delete this row",
  "shipping.warehouseNumber": "Warehouse receipt number",
  "shipping.outboundOrder": "Outbound order",
  "shipping.noMatches": "No matching results",
  "shipping.warehouseSearch": "Search warehouse receipt number",
  "shipping.outboundSearch": "Search outbound order number",
  "shipping.sourceHint":
    "Selecting a warehouse receipt or outbound order links the other field. Available quantities are prefilled and editable; leave unshipped items blank.",
  "shipping.sourceEmpty":
    "No product lines for this warehouse receipt and outbound order.",
  "shipping.requestedQuantity": "Requested outbound quantity",
  "shipping.availableQuantity": "Remaining available quantity",
  "shipping.thisShipment": "This shipment",
  "shipping.enterQuantity": "Enter quantity",
  "shipping.reselectDraft":
    "Reselect a warehouse receipt and outbound order for the existing draft before saving.",
  "shipping.enterRecipient": "Enter recipient",
  "shipping.enterPhone": "Enter contact number",
  "shipping.enterAddress": "Enter full delivery address",
  "shipping.enterCompany": "Enter carrier",
  "shipping.enterTracking": "Enter tracking number",
  "shipping.proofOrRemark": "Shipping proof / remarks",
  "shipping.oneRequired": "Complete at least one",
  "shipping.remarkPlaceholder": "Enter shipping notes or upload proof below",
  "shipping.uploadProof": "Upload proof",
  "shipping.proofFormats": "JPG, PNG or PDF; up to 10 files",
  "shipping.addBatch": "Add next shipment batch",
  "shipping.allShipped": "All order items have been shipped",
  "shipping.submitLocks": "This batch cannot be edited after submission",
  "shipping.readOnly": "Shipped batches are read-only",
  "shipping.submitBatch": "Submit this shipment batch",
  "shipping.queryUnavailable":
    "Query service unavailable. Check the endpoint or deployment.",
  "shipping.queryFailed": "Query failed. Search again.",
  "shipping.orderMissing":
    "An order number is required to create shipping records",
  "shipping.loadFailed": "Failed to load shipping details",
  "shipping.submitCurrent":
    "Submit the current batch before adding the next shipment",
  "shipping.sourceDuplicate":
    "This warehouse receipt and outbound order have already been added. Choose another pair.",
  "shipping.sourceRequired":
    "Reselect a warehouse receipt and outbound order before saving",
  "shipping.saveFailed": "Failed to save shipment. Try again.",
  "shipping.cleanupFailed":
    "Shipment saved, but the local draft could not be cleared. Refresh the page.",
  "shipping.saved": "Shipment batch saved to the server and locked",
  "shipping.draftSaved": "Local draft saved",
  "shipping.deleteConfirmation":
    "Delete this draft? Shipped records are not affected.",
  "shipping.unsavedConfirmation":
    "This batch has unsaved changes. Save a draft before closing?",
  "shipping.unsavedChanges": "Unsaved changes",
  "shipping.saveAndClose": "Save and close",
  "shipping.discard": "Discard changes",
  "shipping.records": "Shipment batches",
  "shipping.loading": "Loading shipment records…",
  "shipping.historyFailed": "Failed to load shipment records",
  "shipping.goodsWarehouse": "Product warehouse receipt",
  "shipping.sourceOutbound": "Source outbound order",
  "shipping.quantity": "Shipment quantity",
  "shipping.receiverInfo": "Recipient details: ",
  "shipping.logisticsInfo": "Shipping details: ",
  "shipping.buyerCompany": "Buyer: ",
  "shipping.warehousePrefix": "Warehouse receipt: ",
  "shipping.orderPrefix": "Order: ",
  "shipping.remarkPrefix": "Remarks: ",
  "shipping.allocatedExceeded":
    "{name}: batch total {quantity} {unit} exceeds the remaining quantity {remaining}",
  "shipping.sold": "Sold",
  "shipping.viewDatasheet": "View datasheet",
  "shipping.businessReview": "Add business approval",
  "shipping.outboundReviewers": "Outbound order reviewers",
  "devUpdates.rejectInspectionsInBulk": "Reject selected inspections",
  "devSync.priceMaxDecimals": "Use at most 4 decimal places",
  "devSync.priceRequired": "Enter a price or amount",
  "devSync.nonnegativePrice": "Enter a value greater than or equal to 0",
  "devSync.searchWarehouseReceipt": "Search by warehouse receipt number",
  "devSync.noMatchingWarehouseReceipt": "No matching warehouse receipt numbers",
  "devSync.warehouseReceiptSearchFailed":
    "Search failed. Enter the warehouse receipt number and try again",
  "devSync.receivedWarehouse": "Receiving warehouse",
  "devSync.savedInspectionReloadFailed":
    "Saved, but details could not be refreshed. Refresh the page before continuing",
  "devSync.deleteReceiptDetailConfirmation":
    "Delete this warehouse receipt detail and its associated inspection details?",
});

export const formDisplay = Object.freeze({
  "devSync.usdCurrencyLabel": "$(USD)",
  "devSync.videos": "videos",
  "devSync.manufacturer": "Manufacturer",
  "devSync.productParameters": "Product parameters",
  "devSync.productDimensions": "Product dimensions",
  "devSync.productQuantityAndUnit": "Product quantity and unit",
  "devSync.productNumber": "Product number",
  "devSync.productCode": "Product code",
  "devSync.productWeight": "Product weight",
  "devSync.certificateOfOrigin": "Certificate of origin",
  "devSync.conversationRenamed": "Conversation renamed",
  "devSync.deep": "Deep",
  "devSync.multiplierSymbol": "×",
  "devSync.questionsRemainingWithoutSigningIn":
    "Questions remaining without signing in:",
  "devSync.receivedStock": "Received stock",
  "devSync.closeVoiceSettings": "Close voice settings",
  "devSync.dispatchWarehouse": "Dispatch warehouse",
  "devSync.dispatchOrderInformation": "Dispatch order information",
  "devSync.dispatchOrderNumber": "Dispatch order number",
  "devSync.dispatchOrderReview": "Dispatch order review",
  "devSync.dispatchOrderReviewer": "Dispatch order reviewer",
  "devSync.dispatchQuantity": "Dispatch quantity",
  "devSync.dispatchDate": "Dispatch date",
  "devSync.dispatchDetails": "Dispatch details",
  "devSync.dispatchAttachments": "Dispatch attachments",
  "devSync.deleteReceiptAndInspectionDetails":
    "Delete receipt and inspection details",
  "devSync.deleteAttachment": "Delete attachment",
  "devSync.addedToCart": "Added to cart",
  "devSync.semitones": "semitones",
  "devSync.publicationType": "Publication type",
  "devSync.priceCurrency": "Price currency",
  "devSync.imagesOrVideosAreUploadingPleaseWait":
    "Images or videos are uploading. Please wait",
  "devSync.failedToReadTheImage": "Failed to read the image",
  "devSync.loadingVoices": "Loading voices…",
  "devSync.voiceSettings": "Voice settings",
  "devSync.bulkPublicationIsComingSoon": "Bulk publication is coming soon",
  "devSync.approvalNumber": "Approval number",
  "devSync.thisBrowserDoesNotSupportRecording":
    "This browser does not support recording",
  "devSync.thisBrowserDoesNotSupportPitchAdjustment":
    "This browser does not support pitch adjustment",
  "devSync.theCameraIsUnavailableInThisBrowserSwitchedToTheSystemCamera":
    "The camera is unavailable in this browser. Switched to the system camera",
  "devSync.fast": "Fast",
  "devSync.restoreDefaults": "Restore defaults",
  "devSync.slow": "Slow",
  "devSync.department": "Department",
  "devSync.holdTheVoiceButtonBelowToSpeak":
    "Hold the voice button below to speak",
  "devSync.multipleFilesSupported": "Multiple files supported",
  "devSync.filesAreUploadingPleaseWaitBeforeSwitchingProducts":
    "Files are uploading. Please wait before switching products",
  "devSync.createProductInformation": "Create product information",
  "devSync.microphonePermissionUnavailable":
    "Microphone permission unavailable",
  "devSync.bright": "Bright",
  "devSync.noDispatchDetails": "No dispatch details",
  "devSync.noSpeechDetectedPleaseTryAgain":
    "No speech detected. Please try again",
  "devSync.keptDuringThisVisitSignInToSave":
    "Kept during this visit; sign in to save",
  "devSync.timesKeptDuringThisVisitSignInToSave":
    "times · Kept during this visit; sign in to save",
  "devSync.loadingInformation": "Loading information…",
  "devSync.addDetails": "Add details",
  "devSync.clickOrDragFilesToUpload": "Click or drag files to upload",
  "devSync.failedToCaptureAPhotoPleaseTryAgain":
    "Failed to capture a photo. Please try again",
  "devSync.signInToViewConversationHistory":
    "Sign in to view conversation history",
  "devSync.theCameraIsNotReadyPleaseTryAgainLater":
    "The camera is not ready. Please try again later",
  "devSync.cameraPermissionUnavailableSwitchedToTheSystemCamera":
    "Camera permission unavailable. Switched to the system camera",
  "devSync.chipType": "Chip type",
  "devSync.thisReceiptIsSavedDeletingItAlsoDeletesItsInspectionDetailsContinue":
    "This receipt is saved. Deleting it also deletes its inspection details. Continue?",
  "devSync.speechSpeed": "Speech speed",
  "devSync.voiceToolbar": "Voice toolbar",
  "devSync.enterThePrimaryContact": "Enter the primary contact",
  "devSync.enterTheManufacturer": "Enter the manufacturer",
  "devSync.enterTheDateCodeDc": "Enter the date code (DC)",
  "devSync.enterAtLeastOneValidReceivedQuantity":
    "Enter at least one valid received quantity",
  "devSync.searchByProductName": "Search by product name",
  "devSync.enterTheProductCode": "Enter the product code",
  "devSync.enterReceivedStock": "Enter received stock",
  "devSync.enterTheDispatchOrderNumber": "Enter the dispatch order number",
  "devSync.enterDispatchOrderNotes": "Enter dispatch order notes",
  "devSync.enterTheDispatchQuantity": "Enter the dispatch quantity",
  "devSync.enterAnAlternativeBrand": "Enter an alternative brand",
  "devSync.enterAnAlternativePartNumber": "Enter an alternative part number",
  "devSync.selectAPdfFileOrImage": "Select a PDF file or image",
  "devSync.selectAWarehouseReceiptNumber": "Select a warehouse receipt number",
  "devSync.selectADispatchWarehouse": "Select a dispatch warehouse",
  "devSync.selectADispatchDate": "Select a dispatch date",
  "devSync.informationIsTemporarilyUnavailable":
    "Information is temporarily unavailable",
  "devSync.carouselImage": "Carousel image",
  "devSync.selectDispatchWarehouse": "Select dispatch warehouse",
  "devSync.selectDispatchDate": "Select dispatch date",
  "devSync.selectAVoice": "Select a voice",
  "devSync.linkOrId": "Link or ID",
  "devSync.attachmentsAndNotes": "Attachments and notes",
  "devSync.pitch": "Pitch",
  "devSync.rejectSalesOrder": "Reject sales order",
  "devSync.verificationIsNotIntegratedYetEnterAnyFourDigits":
    "Verification is not integrated yet. Enter any four digits",
  "devSync.recipient": "Recipient",
  "devSync.recipientPhone": "Recipient phone",
  "devSync.loginFailedCheckYourAccountDetails":
    "Login failed. Check your account details",
  "devSync.turnOffAutomaticSpeech": "Turn off automatic speech",
  "devSync.turnOnAutomaticSpeech": "Turn on automatic speech",
  "devSync.readReplyAloud": "Read reply aloud",
  "devSync.playGeneratedSpeech": "Play generated speech",
  "devSync.generatingSpeechClickToCancel": "Generating speech; click to cancel",
  "devSync.stopReadingAloud": "Stop reading aloud",
  "devSync.awaitingSupervisorConfirmation": "Awaiting supervisor confirmation",
  "devSync.notLoaded": "Not loaded",
  "devSync.noMatchingProducts": "No matching products",
  "devSync.searchFailedEnterYourQueryAgain":
    "Search failed. Enter your query again",
  "devSync.retrievedFilesDocumentsSnippetsSnippets":
    "Retrieved {files} documents · {snippets} snippets",
  "devSync.failedToLoadVoicesPleaseTryAgain":
    "Failed to load voices. Please try again",
  "devSync.failedToGenerateSpeechPleaseTryAgain":
    "Failed to generate speech. Please try again",
  "devSync.snippetWarning":
    "Only relevant snippets enter the model context; retrieval does not imply a final citation",
  "devSync.candidateWarning":
    "Candidate documents enter the model context; this does not imply a final citation",
});

// 目录固定标签
export const catalogDisplay = Object.freeze({
  "devOct15.aiLoading": "Loading XSOU AI…",
  "devOct15.conversationToolbar": "Conversation title and voice controls",
  "devOct15.aiConnecting": "Connecting to the AI assistant…",
  "devOct15.moreSeller": "More seller information",
  "devOct15.standardDisclaimer":
    "Parameters come from the question bank’s standard answers. AI-generated explanations await confirmation; general advice is not a conclusion from this model’s datasheet.",
  "devOct15.viewWiki": "View encyclopedia entry",
  "devOct15.modules": "Memory modules",
  "devOct15.controllers": "Memory interfaces / controllers",
  "devOct15.nonvolatile": "Non-volatile memory",
  "devOct15.otherMemory": "Other memory",
});

// 系统反馈
export const systemFeedback = Object.freeze({
  "devUpdates.startAConversationWithName": "Start a conversation with {name}",
  "devUpdates.sending": "Sending...",
  "devUpdates.failedToSend": "Failed to send",
  "devUpdates.typeAMessage": "Type a message...",
  "devUpdates.loadingProducts": "Loading products…",
  "devUpdates.businessLicenseValidity": "Business license validity",
  "devUpdates.saving": "Saving...",
  "devUpdates.collapseInput": "Collapse input",
  "devUpdates.expandInput": "Expand input",
  "devUpdates.cameraPreview": "Camera preview",
  "devUpdates.confirmCapturedPhoto": "Confirm photo",
  "devUpdates.recognizeAPhoto": "Recognize a photo",
  "devUpdates.confirmPhoto": "Confirm photo",
  "devUpdates.releaseToCancel": "Release to cancel",
  "devUpdates.releaseToSendSlideUpToCancel":
    "Release to send; slide up to cancel",
  "devUpdates.linked": "Linked",
  "devUpdates.notLinked": "Not linked",
  "devUpdates.hideSellerInformation": "Hide seller information",
  "devUpdates.moreSellerInformation": "More seller information",
  "devUpdates.hideBuyerInformation": "Hide buyer information",
  "devUpdates.moreBuyerInformation": "More buyer information",
  "devUpdates.orderReviewer": "Order reviewer",
  "devUpdates.contractReviewer": "Contract reviewer",
  "devUpdates.supplierAttachments": "Supplier attachments",
  "devUpdates.hideSalesOrderInformation": "Hide sales order information",
  "devUpdates.hidePurchaseOrderInformation": "Hide purchase order information",
  "devUpdates.morePurchaseOrderInformation": "More purchase order information",
  "devUpdates.hideAdditionalInformation": "Hide additional information",
  "devUpdates.showAdditionalInformation": "Show additional information",
  "devUpdates.noTaxId": "No tax ID",
  "devUpdates.productNotSpecified": "Product not specified",
  "devUpdates.noPersonInCharge": "No person in charge",
  "devUpdates.asAgreed": "As agreed",
  "devUpdates.seller": "Seller:",
  "devUpdates.orderTotalExceeded": "Order total exceeded",
  "devUpdates.orderTotalUnpaid": "Order total unpaid",
  "devUpdates.hongKongAccount": "Hong Kong account",
  "devUpdates.mainlandChinaAccount": "Mainland China account",
  "devUpdates.secondsBeforeResending": "seconds before resending",
  "devUpdates.noApprovalNotes": "No approval notes",
  "devUpdates.previouslyTraded": "Previously traded",
  "devUpdates.noPreviousTrades": "No previous trades",
  "devUpdates.ordinalPrefix": "No. ",
  "devUpdates.installment": " installment",
  "devUpdates.searchReviewers": "Search reviewers",
  "devUpdates.reviewer": "Reviewer",
  "devUpdates.uploadThisInstallmentsPaymentReceipt":
    "Upload this installment's payment receipt",
  "devUpdates.confirmed": "(Confirmed)",
  "devUpdates.unconfirmed": "(Unconfirmed)",
  "devUpdates.uploadPaymentMethodAttachments":
    "Upload payment method attachments",
  "devUpdates.bidClosingReview": "Bid closing review",
  "devUpdates.publicationInformation": "Publication information",
  "devUpdates.bidClosingInformation": "Bid closing information",
  "devUpdates.singlePublication": "Single publication",
  "devUpdates.biddingReviewDetails": "Bidding review details",
  "devUpdates.bidClosingReviewDetails": "Bid closing review details",
  "devUpdates.saveInspectionRecord": "Save inspection record",
  "devUpdates.inspectionReview": "Inspection review",
  "devUpdates.confirmInspectionsInBulk": "Confirm inspections in bulk",
  "devUpdates.confirmInspection": "Confirm inspection",
  "devUpdates.uploadedDocuments": "Uploaded documents",
  "devUpdates.generatingWikiContent": "Generating wiki content...",
  "devUpdates.aiWikiQA": "AI wiki Q&A",
  "devUpdates.wikiQA": "Wiki Q&A",
  "devUpdates.qAEntries": "Q&A entries",
  "devUpdates.discussions": "discussions",
  "devUpdates.generatingQAFromWikiSections":
    "Generating Q&A from wiki sections...",
  "devUpdates.basedOnSpecificationsTechnicalFeaturesApplicationsAndPrecautions":
    "Based on specifications, technical features, applications and precautions",
  "devUpdates.noDiscussionsForThisProductPopularQAIsShownInstead":
    "No discussions for this product. Popular Q&A is shown instead",
  "devUpdates.currentProductDiscussions": "Current product discussions",
  "devUpdates.reviewPaymentReceipt": "Review payment receipt",
  "devUpdates.reviewPaymentMethod": "Review payment method",
  "devUpdates.selectPaymentMethod": "Select payment method",
  "devUpdates.paymentReceiptReviewer": "Payment receipt reviewer",
  "devUpdates.paymentMethodReviewer": "Payment method reviewer",
  "devUpdates.onlyJpgPngGifAndBmpImagesAreSupported":
    "Only JPG, PNG, GIF and BMP images are supported",
  "devUpdates.imagesMustNotExceed10Mb": "Images must not exceed 10 MB",
  "devUpdates.onlyImagesAreSupported": "Only images are supported",
  "devUpdates.imageSizeLimit": "Images must not exceed 10 MB",
  "devUpdates.selectAnImageOrEnterTextFirst":
    "Select an image or enter text first",
  "devUpdates.requestFailed": "Request failed",
  "devUpdates.theImagePickerIsNotReady": "The image picker is not ready",
  "devUpdates.onlyPdfPngAndJpgFilesAreSupported":
    "Only PDF, PNG and JPG files are supported",
  "devUpdates.filesMustNotExceed10Mb": "Files must not exceed 10 MB",
  "devUpdates.onlyPngAndJpgImagesAreSupported":
    "Only PNG and JPG images are supported",
  "devUpdates.recognitionSucceeded": "Recognition succeeded ✅",
  "devUpdates.copied": "Copied",
  "devUpdates.productLinkedSuccessfully": "Product linked successfully",
  "devUpdates.thisPageSupportsPurchaseOrderAndPurchaseContractReviewOnly":
    "This page supports purchase order and purchase contract review only",
  "devUpdates.failedToLoadApprovalStatus": "Failed to load approval status",
  "devUpdates.uploadTheContractFileFirst": "Upload the contract file first",
  "devUpdates.theContractFileIsUnchangedNoUploadIsNeeded":
    "The contract file is unchanged. No upload is needed",
  "devUpdates.relatedContentUpdated": "Related content updated",
  "devUpdates.removedSuccessfully": "Removed successfully",
  "devUpdates.contractApprovalRequested": "Contract approval requested",
  "devUpdates.enterTheRejectionReason": "Enter the rejection reason",
  "devUpdates.unsupportedDownloadResponse": "Unsupported download response",
  "devUpdates.fileDownloaded": "File downloaded",
  "devUpdates.downloadFailedTheServerReturnedAnError":
    "Download failed: the server returned an error",
  "devUpdates.paymentApproved": "Payment approved",
  "devUpdates.paymentRequestRejected": "Payment request rejected",
  "devUpdates.contractIdIsMissing": "Contract ID is missing",
  "devUpdates.failedToLoadContractData": "Failed to load contract data",
  "devUpdates.theCustomerUploadedASingleStampedContractThisOptionCannotBeChanged":
    "The customer uploaded a single-stamped contract. This option cannot be changed",
  "devUpdates.chooseEitherAContractTemplateOrASingleStampedContractForApproval":
    "Choose either a contract template or a single-stamped contract for approval",
  "devUpdates.uploadAContractTemplateOrASingleStampedContractFirst":
    "Upload a contract template or a single-stamped contract first",
  "devUpdates.theTemplateIsEmpty": "The template is empty",
  "devUpdates.templateSaved": "Template saved",
  "devUpdates.failedToSaveTemplate": "Failed to save template",
  "devUpdates.thisReviewerHasAlreadyBeenAdded":
    "This reviewer has already been added",
  "devUpdates.uploadTheInvInvoiceFirst": "Upload the INV invoice first",
  "devUpdates.invApprovalRequested": "INV approval requested",
  "devUpdates.invApproved": "INV approved",
  "devUpdates.failedToInitializeTheSellerCompany":
    "Failed to initialize the seller company",
  "devUpdates.bankAddedSuccessfully": "Bank added successfully",
  "devUpdates.imageFileSizeLimit": "Images must not exceed 10 MB",
  "devUpdates.relatedContentRemoved": "Related content removed",
  "devUpdates.paymentApprovalRequested": "Payment approval requested",
  "devUpdates.mergedSuccessfully": "Merged successfully",
  "devUpdates.failedToSearchCompanies": "Failed to search companies",
  "devUpdates.failedToLoadCompanies": "Failed to load companies",
  "devUpdates.companyProfileAdded": "Company profile added",
  "devUpdates.addressAdded": "Address added",
  "devUpdates.addressChanged": "Address changed",
  "devUpdates.enterASearchKeywordFirst": "Enter a search keyword first",
  "devUpdates.aSalesOrderCannotBeGeneratedForThisOrderYet":
    "A sales order cannot be generated for this order yet",
  "devUpdates.selectAtLeastOneSellerReviewer":
    "Select at least one seller reviewer",
  "devUpdates.selectTheSellerCompany": "Select the seller company",
  "devUpdates.productConditionIsRequired": "Product condition is required",
  "devUpdates.validationFailedCheckTheFormFields":
    "Validation failed. Check the form fields",
  "devUpdates.selectThePriceCurrency": "Select the price currency",
  "devUpdates.orderContractGenerated": "Order contract generated",
  "devUpdates.orderIdIsMissingTheOrderCannotBeRejected":
    "Order ID is missing. The order cannot be rejected",
  "devUpdates.failedToLoadData": "Failed to load data",
  "devUpdates.installmentsCannotExceedTheAmountDue":
    "Installments cannot exceed the amount due",
  "devUpdates.onlyOneUnpaidInstallmentCanBeAddedAtATime":
    "Only one unpaid installment can be added at a time",
  "devUpdates.theUnpaidBalanceIsZeroNoMoreInstallmentsCanBeAdded":
    "The unpaid balance is zero. No more installments can be added",
  "devUpdates.upToFiveInstallmentsAreSupported":
    "Up to five installments are supported",
  "devUpdates.enterTheFirstInstallmentAmountAndPaymentDate":
    "Enter the first installment amount and payment date",
  "devUpdates.paymentMethodSubmittedForReview":
    "Payment method submitted for review",
  "devUpdates.uploadAPaymentReceipt": "Upload a payment receipt",
  "devUpdates.submittedToPurchasingTeam":
    "Submitted to the purchasing team: 黄心雨",
  "devUpdates.paymentReceiptConfirmed": "Payment receipt confirmed",
  "devUpdates.paymentMethodApproved": "Payment method approved",
  "devUpdates.enterAValidMobileVerificationCode":
    "Enter a valid mobile verification code",
  "devUpdates.areYouSureYouWantToLogOut": "Are you sure you want to log out?",
  "devUpdates.logoutCancelled": "Logout cancelled",
  "devUpdates.linkedSuccessfully": "Linked successfully",
  "devUpdates.bankDetailsCopied": "Bank details copied",
  "devUpdates.failedToLoadBanks": "Failed to load banks",
  "devUpdates.linkedBanksUpdated": "Linked banks updated",
  "devUpdates.failedToUpdateLinkedBanks": "Failed to update linked banks",
  "devUpdates.failedToLoadSuppliers": "Failed to load suppliers",
  "devUpdates.failedToLoadSupplierProfile": "Failed to load supplier profile",
  "devUpdates.bankCreated": "Bank created",
  "devUpdates.failedToLoadBiddingInformation":
    "Failed to load bidding information",
  "devUpdates.selectACompanyFirst": "Select a company first",
  "devUpdates.bankDetailsAddedAndFilledInAutomatically":
    "Bank details added and filled in automatically",
  "devUpdates.failedToAddCompany": "Failed to add company",
  "devUpdates.batchUploadIsComingSoon": "Batch upload is coming soon",
  "devUpdates.selectTheProductLocation": "Select the product location",
  "devUpdates.selectThePublicationDate": "Select the publication date",
  "devUpdates.selectTheBiddingDeadline": "Select the bidding deadline",
  "devUpdates.selectTheBidOpeningTime": "Select the bid opening time",
  "devUpdates.uploadAnExcelFileFirst": "Upload an Excel file first",
  "devUpdates.batchPublicationFailedTryAgainLater":
    "Batch publication failed. Try again later",
  "devUpdates.onlyXlsxAndXlsFilesAreSupported":
    "Only .xlsx and .xls files are supported",
  "devUpdates.cannotReadTheExcelWorksheet": "Cannot read the Excel worksheet",
  "devUpdates.theExcelFileIsEmpty": "The Excel file is empty",
  "devUpdates.theExcelFileContainsNoData": "The Excel file contains no data",
  "devUpdates.biddingImportPartNumberColumnRequired":
    'No valid bidding data. Ensure the Excel file contains a "料号" (part number) column',
  "devUpdates.failedToReadFile": "Failed to read file",
  "devUpdates.completeAtLeastOneField": "Complete at least one field",
  "devUpdates.selectPackaging": "Select packaging",
  "devUpdates.selectAPackage": "Select a package",
  "devUpdates.uploadThisContractItCannotBeEditedAfterTheOtherPartyApprovesIt":
    "Upload this contract? It cannot be edited after the other party approves it",
  "devUpdates.relatedOrdersAdded": "Related orders added",
  "devUpdates.approveDualStampedContractConfirmation":
    "Approve the dual-stamped contract? After the other party approves it, the workflow ends and the contract cannot be edited",
  "devUpdates.dualStampedContractApproved": "Dual-stamped contract approved",
  "devUpdates.requestInvApproval": "Request INV approval?",
  "devUpdates.operationSucceeded": "Operation succeeded",
  "devUpdates.completeTheRequiredFields": "Complete the required fields",
  "devUpdates.quoteSubmitted": "Quote submitted",
  "devUpdates.relatedOrderRemoved": "Related order removed",
  "devUpdates.aSingleOrderDoesNotNeedMerging":
    "A single order does not need merging",
  "devUpdates.selectOrdersToMerge": "Select orders to merge",
  "devUpdates.checkTheRequiredFields": "Check the required fields",
  "devUpdates.submitThePaymentMethodForReview":
    "Submit the payment method for review?",
  "devUpdates.paymentReceiptRejected": "Payment receipt rejected",
  "devUpdates.confirmThePaymentReceiptIsCorrectTheSupplierCanThenViewAndDownloadIt":
    "Confirm the payment receipt is correct? The supplier can then view and download it",
  "devUpdates.approveThePaymentMethod": "Approve the payment method?",
  "devUpdates.paymentMethodRejected": "Payment method rejected",
  "devUpdates.enterTheBusinessEmail": "Enter the business email",
  "devUpdates.enterTheAccountAndPassword": "Enter the account and password",
  "devUpdates.readAndAcceptTheAgreements": "Read and accept the agreements",
  "devUpdates.thePasswordMustContain620Characters":
    "The password must contain 6–20 characters",
  "devUpdates.enterTheFullCompanyName": "Enter the full company name",
  "devUpdates.failedToLoadBiddingReviewData":
    "Failed to load bidding review data",
  "devUpdates.failedToLoadReviewDetailsTryAgainLater":
    "Failed to load review details. Try again later",
  "devUpdates.thisWarehouseReceiptHasBeenSavedDeleteIt":
    "This warehouse receipt has been saved. Delete it?",
  "devUpdates.enterDatesAndReceiptNumbersForAllWarehouseReceipts":
    "Enter dates and receipt numbers for all warehouse receipts",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeSwitchingProducts":
    "Images or videos are uploading. Wait before switching products",
  "devUpdates.productNumberIsMissing": "Product number is missing",
  "devUpdates.selectAtLeastOneProduct": "Select at least one product",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeConfirmingInspection":
    "Images or videos are uploading. Wait before confirming inspection",
  "devUpdates.yourRoleCannotSaveInspectionImagesOrTerms":
    "Your role cannot save inspection images or terms",
  "devUpdates.eachWarehouseReceiptQuantityMustBeGreaterThanZero":
    "Each warehouse receipt quantity must be greater than zero",
  "devUpdates.inspectionQuantityIsRequired": "Inspection quantity is required",
  "devUpdates.currentProductSaved": "Current product saved",
  "devUpdates.theCurrentStatusDoesNotAllowInspectionConfirmation":
    "The current status does not allow inspection confirmation",
  "devUpdates.enterApprovalNotes": "Enter approval notes",
  "devUpdates.inspectionConfirmed": "Inspection confirmed",
  "devUpdates.theCurrentStatusDoesNotAllowRejection":
    "The current status does not allow rejection",
  "devUpdates.rejectionReasonRequired": "Enter the rejection reason",
  "devUpdates.rejectedSuccessfully": "Rejected successfully",
  "devUpdates.warning": "Warning",
  "devUpdates.selectProductSpecificationsFirst":
    "Select product specifications first",
  "devUpdates.insufficientStockForTheSelectedSpecifications":
    "Insufficient stock for the selected specifications",
  "devUpdates.withdrawingStopsReviewAndSavesAPrivateDraftYouCanThenEditOrDeleteIt":
    "Withdrawing stops review and saves a private draft. You can then edit or delete it",
  "devUpdates.confirmWithdrawal": "Confirm withdrawal",
  "devUpdates.submissionWithdrawnAndSavedAsADraftOutsideTheReviewQueue":
    "Submission withdrawn and saved as a draft outside the review queue",
  "devUpdates.deletingRemovesThisDraftFromMyPublicationsAndCannotBeUndone":
    "Deleting removes this draft from My publications and cannot be undone",
  "devUpdates.confirmDraftDeletion": "Confirm draft deletion",
  "devUpdates.draftDeleted": "Draft deleted",
  "devUpdates.noReadableDatasheetPdfIsLinkedToThisSource":
    "No readable datasheet PDF is linked to this source",
  "devUpdates.logInToViewTheFullDatasheet": "Log in to view the full datasheet",
  "devUpdates.failedToLoadKnowledgeBaseDetailsTryAgainLater":
    "Failed to load knowledge base details. Try again later",
  "devUpdates.entryNameCopied": "Entry name copied",
  "devUpdates.failedToLoadVersionHistoryTryAgainLater":
    "Failed to load version history. Try again later",
  "devUpdates.noPublishedHistoricalVersions":
    "No published historical versions",
  "devUpdates.thisAccountCannotReviewWikiEntries":
    "This account cannot review wiki entries",
  "devUpdates.aManualReviewMustApproveReturnForRevisionOrReject":
    "A manual review must approve, return for revision or reject",
  "devUpdates.logInBeforeSaving": "Log in before saving",
  "devUpdates.noDatasheetsAvailableToDownload":
    "No datasheets available to download",
  "devUpdates.protectedDownloadIsUnavailableDownloadFromTheKnowledgeBaseProductPage":
    "Protected download is unavailable. Download from the knowledge base product page",
  "devUpdates.logInToDownloadTheDatasheet": "Log in to download the datasheet",
  "devUpdates.cannotLoadDownloadCreditsTryAgainLater":
    "Cannot load download credits. Try again later",
  "devUpdates.confirmDatasheetDownload": "Confirm datasheet download",
  "devUpdates.datasheetDownloadsAreUnavailableTryAgainLater":
    "Datasheet downloads are unavailable. Try again later",
  "devUpdates.downloadingDatasheetUnlimitedFreeDownloadsForAdministrators":
    "Downloading datasheet (unlimited free downloads for administrators)",
  "devUpdates.downloadingAPurchasedDatasheetNoCreditsDeducted":
    "Downloading a purchased datasheet (no credits deducted)",
  "devUpdates.dataExportStarted": "Data export started",
  "devUpdates.failedToLoadWikiProductsTryAgainLater":
    "Failed to load wiki products. Try again later",
  "devUpdates.failedToLoadMoreProductsTryAgainLater":
    "Failed to load more products. Try again later",
  "devUpdates.datasheetsMustBePdfFiles": "Datasheets must be PDF files",
  "devUpdates.datasheetsMustNotExceed50Mb": "Datasheets must not exceed 50 MB",
  "devUpdates.eachWikiEntryAllowsOneDatasheetRemoveTheSelectedFileFirst":
    "Each wiki entry allows one datasheet. Remove the selected file first",
  "devUpdates.failedToLoadScheduledPublication":
    "Failed to load scheduled publication",
  "devUpdates.immediatePublicationFailed": "Immediate publication failed",
  "devUpdates.cancelScheduledPublication": "Cancel scheduled publication",
  "devUpdates.scheduledPublicationCancelledTheEntryWasSavedAsADraft":
    "Scheduled publication cancelled; the entry was saved as a draft",
  "devUpdates.failedToCancelScheduledPublication":
    "Failed to cancel scheduled publication",
  "devUpdates.thisFileFormatIsNotSupported":
    "This file format is not supported",
  "devUpdates.noPublishableWikiContentRecognized":
    "No publishable wiki content recognized",
  "devUpdates.fileParsingFailedCheckTheFileContents":
    "File parsing failed. Check the file contents",
  "devUpdates.requiredFieldsMissing": "Complete the required fields",
  "devUpdates.selectAFuturePublicationTime": "Select a future publication time",
  "devUpdates.datasheetPromotionalContentWarning":
    "The PDF may contain advertising or promotional redirects. Upload an appropriate official datasheet",
  "devUpdates.thePdfIsUnrelatedToChipSpecificationsSelectTheDatasheetForThisPart":
    "The PDF is unrelated to chip specifications. Select the datasheet for this part",
  "devUpdates.datasheetTextExtractionManualReviewHint":
    "Text cannot be extracted from this PDF. Submission requires manual review rather than automatic publication",
  "devUpdates.addAtLeastOneWikiEntry": "Add at least one wiki entry",
  "devUpdates.batchSubmissionStoppedOnFailure":
    "A submission failed. Later submissions were stopped and unfinished data was retained. Check and retry",
  "devUpdates.answerDeleted": "Answer deleted",
  "devUpdates.commentDeleted": "Comment deleted",
  "devUpdates.commentPublished": "Comment published",
  "devUpdates.newCompanyProfile": "New company profile",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsForPurchaseOrders":
    "Enter company details, certificates and linked accounts for purchase orders",
  "devUpdates.mainlandChinaCompany": "Mainland China company",
  "devUpdates.hongKongMacaoOrTaiwanCompany":
    "Hong Kong, Macao or Taiwan company",
  "devUpdates.enterTextOrPasteAnImage": "Enter text or paste an image",
  "devUpdates.supplierShortName": "Supplier short name",
  "devUpdates.enterTheSupplierShortName": "Enter the supplier short name",
  "devUpdates.enterTheCompanyNameInEnglish":
    "Enter the company name in English",
  "devUpdates.companyCode": "Company code",
  "devUpdates.enterTheCompanyCode": "Enter the company code",
  "devUpdates.legalRepresentative": "Legal representative",
  "devUpdates.enterTheLegalRepresentative": "Enter the legal representative",
  "devUpdates.searchLinkedCompanies": "Search linked companies",
  "devUpdates.noMatchingCompanies": "No matching companies",
  "devUpdates.enterTheCompanyAddress": "Enter the company address",
  "devUpdates.enterTheCompanyPhoneNumber": "Enter the company phone number",
  "devUpdates.linkedBankAccounts": "Linked bank accounts",
  "devUpdates.noBankAccountsAvailableToLink":
    "No bank accounts available to link",
  "devUpdates.uploadAFrameworkAgreement": "Upload a framework agreement",
  "devUpdates.uploadASupplierQuestionnaire": "Upload a supplier questionnaire",
  "devUpdates.uploadAnAuditReport": "Upload an audit report",
  "devUpdates.submitCompanyProfile": "Submit company profile",
  "devUpdates.taxIdAndMainlandChinaBankDetails":
    "Tax ID and mainland China bank details",
  "devUpdates.registrationNumberAndOverseasBankDetails":
    "Registration number and overseas bank details",
  "devUpdates.imagePreviewForRecognition": "Image preview for recognition",
  "devUpdates.removeImageForRecognition": "Remove image for recognition",
  "devUpdates.companyAttributes": "Company attributes",
  "devUpdates.parentCompany": "Parent company",
  "devUpdates.searchCompaniesToLink": "Search companies to link",
  "devUpdates.multipleSelectionsAllowed": "Multiple selections allowed",
  "devUpdates.selected": "· Selected",
  "devUpdates.items": "items",
  "devUpdates.noLinkableBankAccounts": "No bank accounts available to link",
  "devUpdates.selectCompaniesToLink": "Select companies to link",
  "devUpdates.searchCompanyNames": "Search company names",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsToManageSuppliers":
    "Enter company details, certificates and linked accounts to manage suppliers",
  "devUpdates.smartRecognitionPdfPngAndJpg":
    "Smart recognition (PDF, PNG and JPG)",
  "devUpdates.enterTextOrPasteCompanyDetails":
    "Enter text or paste company details",
  "devUpdates.companyLocation": "Company location",
  "devUpdates.selectCountryProvinceCityAndDistrict":
    "Select country, province, city and district",
  "devUpdates.reportYear": "Report year",
  "devUpdates.selectAYear": "Select a year",
  "devUpdates.searchPastConversations": "Search past conversations",
  "devUpdates.search": "Search...",
  "devUpdates.newConversation": "New conversation",
  "devUpdates.noMatchingConversations": "No matching conversations",
  "devUpdates.backToXsouAi": "Back to XSOU AI",
  "devUpdates.goToProfile": "Go to profile",
  "devUpdates.scanComingSoon": "Scan (coming soon)",
  "devUpdates.comingSoon": "Coming soon",
  "devUpdates.remindersComingSoon": "Reminders (coming soon)",
  "devUpdates.settingsComingSoon": "Settings (coming soon)",
  "devUpdates.conversationActions": "Conversation actions",
  "devUpdates.renameConversation": "Rename conversation",
  "devUpdates.removeFromConversations": "Remove from conversations",
  "devUpdates.conversationName": "Conversation name",
  "devUpdates.findInConversation": "Find in conversation",
  "devUpdates.clearSearch": "Clear search",
  "devUpdates.cancelSearch": "Cancel search",
  "devUpdates.enterAKeywordToSearchThisConversation":
    "Enter a keyword to search this conversation",
  "devUpdates.noMatchingContentInThisConversation":
    "No matching content in this conversation",
  "devUpdates.pastConversations": "Past conversations",
  "devUpdates.aiGeneratedContent": "AI-generated content",
  "devUpdates.voiceCallComingSoon": "Voice call (coming soon)",
  "devUpdates.speakerComingSoon": "Speaker (coming soon)",
  "devUpdates.currentConversationActions": "Current conversation actions",
  "devUpdates.createAConversation": "Create a conversation",
  "devUpdates.searchKeywordsAndReferences": "Search keywords and references",
  "devUpdates.responseActions": "Response actions",
  "devUpdates.copyResponse": "Copy response",
  "devUpdates.readAloudComingSoon": "Read aloud (coming soon)",
  "devUpdates.readResponseAloudComingSoon": "Read response aloud (coming soon)",
  "devUpdates.saveComingSoon": "Save (coming soon)",
  "devUpdates.saveResponseComingSoon": "Save response (coming soon)",
  "devUpdates.shareComingSoon": "Share (coming soon)",
  "devUpdates.shareResponseComingSoon": "Share response (coming soon)",
  "devUpdates.regenerateComingSoon": "Regenerate (coming soon)",
  "devUpdates.regenerateResponseComingSoon":
    "Regenerate response (coming soon)",
  "devUpdates.generating": "Generating",
  "devUpdates.goToLatestMessage": "Go to latest message",
  "devUpdates.takeAPhotoOrUploadAFileComingSoon":
    "Take a photo or upload a file (coming soon)",
  "devUpdates.sendAMessage": "Send a message...",
  "devUpdates.voiceInputComingSoon": "Voice input (coming soon)",
  "devUpdates.addComingSoon": "Add (coming soon)",
  "devUpdates.cancelUpload": "Cancel upload",
  "devUpdates.chipPhotoToUpload": "Chip photo to upload",
  "devUpdates.takeAPhoto": "Take a photo",
  "devUpdates.retakePhoto": "Retake photo",
  "devUpdates.confirmUpload": "Confirm upload",
  "devUpdates.references": "References",
  "devUpdates.onlySourcesCitedInThisResponseAreShown":
    "Only sources cited in this response are shown.",
  "devUpdates.mainNavigation": "Main navigation",
  "devUpdates.bidding": "Bidding",
  "devUpdates.changeLanguage": "Change language",
  "devUpdates.celebratingTheFoundingOfThePeoplesRepublicOfChina":
    "Celebrating the founding of the People's Republic of China",
  "devUpdates.anniversary": "anniversary",
  "devUpdates.quickPartNumberSearch": "Quick part-number search",
  "devUpdates.quickSearch": "Quick search",
  "devUpdates.copyright20172026XsouTechnology":
    "Copyright © 2017-2026 XSOU Technology (",
  "devUpdates.closeHolidayGreeting": "Close holiday greeting",
  "devUpdates.xsouHolidayLogo": "XSOU holiday logo",
  "devUpdates.thisProductIsAlreadyLinked": "This product is already linked",
  "devUpdates.logInBeforeLinkingTheProduct":
    "Log in before linking the product",
  "devUpdates.confirmLinking": "Confirm linking",
  "devUpdates.contractApprovalSteps": "Contract approval steps",
  "devUpdates.copySellerInvitationLink": "Copy seller invitation link",
  "devUpdates.partNumber": "Part number:",
  "devUpdates.productId": "Product ID:",
  "devUpdates.orderAttachments": "Order attachments",
  "devUpdates.files": "files",
  "devUpdates.relatedContent": "Related content",
  "devUpdates.sellerReviewer": "Seller reviewer",
  "devUpdates.noSellerReviewers": "No seller reviewers",
  "devUpdates.addReviewer": "Add reviewer",
  "devUpdates.noReviewersAdded": "No reviewers added",
  "devUpdates.downloadContractTemplate": "Download contract template",
  "devUpdates.generatePoPurchaseOrder": "Generate PO purchase order",
  "devUpdates.generatePiProFormaInvoice": "Generate PI pro forma invoice",
  "devUpdates.generatePlPackingList": "Generate PL packing list",
  "devUpdates.generateInvContract": "Generate INV contract",
  "devUpdates.generateDeliveryNote": "Generate delivery note",
  "devUpdates.generateSalesContract": "Generate sales contract",
  "devUpdates.supplierUploadsASingleStampedContract":
    "Supplier uploads a single-stamped contract",
  "devUpdates.addRelatedContent": "Add related content",
  "devUpdates.noRelatedContentAdded": "No related content added",
  "devUpdates.viewDocuments": "View documents",
  "devUpdates.documents": "Documents",
  "devUpdates.previous": "Previous",
  "devUpdates.next": "Next",
  "devUpdates.noMatchingCcRecipients": "No matching CC recipients",
  "devUpdates.documentDetails": "Document details",
  "devUpdates.closeDocumentDetails": "Close document details",
  "devUpdates.salesOrderProducts": "Sales order products",
  "devUpdates.thisPageIsCurrentlyUnavailable":
    "This page is currently unavailable",
  "devUpdates.loadingPaymentInformation": "Loading payment information",
  "devUpdates.paymentNotes": "Payment notes",
  "devUpdates.paymentRequestNotes": "Payment request notes",
  "devUpdates.paymentApprovalWorkflow": "Payment approval workflow",
  "devUpdates.backToOrder": "Back to order",
  "devUpdates.noRelatedContent": "No related content",
  "devUpdates.purchaseOrderProducts": "Purchase order products",
  "devUpdates.invReviewer": "INV reviewer",
  "devUpdates.purchaseOrderSteps": "Purchase order steps",
  "devUpdates.switchAccount": "Switch account",
  "devUpdates.selectProductProvider": "Select product provider",
  "devUpdates.addPurchaseProduct": "Add purchase product",
  "devUpdates.enterTheProductBrand": "Enter the product brand",
  "devUpdates.enterThePartNumber": "Enter the part number",
  "devUpdates.enterTheUnitPrice": "Enter the unit price",
  "devUpdates.quantityUnit": "Quantity / unit",
  "devUpdates.enterThePurchaseQuantity": "Enter the purchase quantity",
  "devUpdates.productUnit": "Product unit",
  "devUpdates.enterTheProductTotal": "Enter the product total",
  "devUpdates.enterTheDeliveryRegion": "Enter the delivery region",
  "devUpdates.enterTheDateCodeDc": "Enter the date code (DC)",
  "devUpdates.productConditionMultipleSelections":
    "Product condition (multiple selections)",
  "devUpdates.noPurchaseProductsAddProductsInPurchaseSettings":
    "No purchase products. Add products in purchase settings.",
  "devUpdates.theContractNumberIsGeneratedAfterSelectingTheSellerCompany":
    "The contract number is generated after selecting the seller company",
  "devUpdates.duplicatesAllowed": "Duplicates allowed",
  "devUpdates.selectADeliveryDate": "Select a delivery date",
  "devUpdates.asNegotiated": "As agreed",
  "devUpdates.selectAPurchaseNegotiator": "Select a purchase negotiator",
  "devUpdates.estimatedCommission": "Estimated commission",
  "devUpdates.enterTheEstimatedCommission": "Enter the estimated commission",
  "devUpdates.enterTheAfterSalesTerms": "Enter the after-sales terms",
  "devUpdates.enterOrderNotes": "Enter order notes",
  "devUpdates.selectOrEnterTheCompanyName": "Select or enter the company name",
  "devUpdates.create": "Create",
  "devUpdates.enterTheFullAddress": "Enter the full address",
  "devUpdates.enterTheBankNameInEnglish": "Enter the bank name in English",
  "devUpdates.enterTheBankNameInChinese": "Enter the bank name in Chinese",
  "devUpdates.enterTheAccountBank": "Enter the account bank",
  "devUpdates.enterTheBankAccountNumber": "Enter the bank account number",
  "devUpdates.enterTheSwiftCode": "Enter the SWIFT code",
  "devUpdates.enterTheBankCode": "Enter the bank code",
  "devUpdates.bankAddressChinese": "Bank address (Chinese)",
  "devUpdates.enterTheBankAddressInChinese":
    "Enter the bank address in Chinese",
  "devUpdates.bankAddressEnglish": "Bank address (English)",
  "devUpdates.enterTheBankAddressInEnglish":
    "Enter the bank address in English",
  "devUpdates.enterTheShippingAddress": "Enter the shipping address",
  "devUpdates.orderSubmission": "Order submission",
  "devUpdates.purchaseQuote": "Purchase quote",
  "devUpdates.generateOrder": "Generate order",
  "devUpdates.selectDeliveryDate": "Select delivery date",
  "devUpdates.selectPurchaseNegotiator": "Select purchase negotiator",
  "devUpdates.searchPurchaseNegotiators": "Search purchase negotiators",
  "devUpdates.noMatchingNegotiators": "No matching negotiators",
  "devUpdates.enterANameToSearchPurchaseNegotiators":
    "Enter a name to search purchase negotiators",
  "devUpdates.companies": "Companies",
  "devUpdates.total": "Total",
  "devUpdates.companyCountUnit": "companies",
  "devUpdates.noCompanyProfiles": "No company profiles",
  "devUpdates.loadingOrderInformation": "Loading order information",
  "devUpdates.requestPaymentApproval": "Request payment approval",
  "devUpdates.salesOrderSteps": "Sales order steps",
  "devUpdates.selectTheProductBrand": "Select the product brand",
  "devUpdates.enterTheSalesQuantity": "Enter the sales quantity",
  "devUpdates.selectTheDeliveryRegion": "Select the delivery region",
  "devUpdates.selectASalesNegotiator": "Select a sales negotiator",
  "devUpdates.clearSalesNegotiator": "Clear sales negotiator",
  "devUpdates.selectACompany": "Select a company",
  "devUpdates.enterThePrimaryContact": "Enter the primary contact",
  "devUpdates.change": "Change",
  "devUpdates.clearSellerContact": "Clear seller contact",
  "devUpdates.clearSellerPhoneNumber": "Clear seller phone number",
  "devUpdates.enterTheSellerTaxId": "Enter the seller tax ID",
  "devUpdates.selectABank": "Select a bank",
  "devUpdates.enterTheBankBranch": "Enter the bank branch",
  "devUpdates.enterTheBankRoutingNumber": "Enter the bank routing number",
  "devUpdates.clearBuyerContact": "Clear buyer contact",
  "devUpdates.clearBuyerPhoneNumber": "Clear buyer phone number",
  "devUpdates.enterTheBuyerTaxId": "Enter the buyer tax ID",
  "devUpdates.selectAShippingAddress": "Select a shipping address",
  "devUpdates.salesOrderSubmission": "Sales order submission",
  "devUpdates.mergeOrderSelection": "Select orders to merge",
  "devUpdates.selectSalesNegotiator": "Select sales negotiator",
  "devUpdates.searchNegotiators": "Search negotiators",
  "devUpdates.negotiators": "Negotiators",
  "devUpdates.people": "people",
  "devUpdates.noNegotiators": "No negotiators",
  "devUpdates.confirmOrderInformation": "Confirm order information",
  "devUpdates.orderSummary": "Order summary",
  "devUpdates.contractAndDelivery": "Contract and delivery",
  "devUpdates.backToEdit": "Back to edit",
  "devUpdates.purchaseDetails": "Purchase details",
  "devUpdates.tradeInformation": "Trade information",
  "devUpdates.purchaseQuantity": "Purchase quantity",
  "devUpdates.buyerWechat": "Buyer WeChat",
  "devUpdates.orderTime": "Order time",
  "devUpdates.productDocuments": "Product documents",
  "devUpdates.sellerWechat": "Seller WeChat",
  "devUpdates.negotiatorPhoneNumber": "Negotiator phone number",
  "devUpdates.generateContract": "Generate contract",
  "devUpdates.generateTradeContract": "Generate trade contract",
  "devUpdates.tradePrice": "Trade price",
  "devUpdates.tradeQuantity": "Trade quantity",
  "devUpdates.buyerTransactionFee": "Buyer transaction fee",
  "devUpdates.sellerTransactionFee": "Seller transaction fee",
  "devUpdates.productAmount": "Product amount",
  "devUpdates.amountDue": "Amount due",
  "devUpdates.readOnly": "Read-only",
  "devUpdates.paymentAmount": "Payment amount",
  "devUpdates.submittingPaysTheFullAmountDueInOnePayment":
    "Submitting pays the full amount due in one payment",
  "devUpdates.completeOrder": "Complete order",
  "devUpdates.deleteInstallment": "Delete installment",
  "devUpdates.installmentName": "Installment name",
  "devUpdates.enterTheInstallmentName": "Enter the installment name",
  "devUpdates.requestedInstallmentAmount": "Requested installment amount",
  "devUpdates.enterThePaymentAmount": "Enter the payment amount",
  "devUpdates.percentage": "Percentage",
  "devUpdates.paymentDate": "Payment date",
  "devUpdates.selectAPaymentDate": "Select a payment date",
  "devUpdates.selectTheOrderingCompany": "Select the ordering company",
  "devUpdates.paymentBank": "Payment bank",
  "devUpdates.selectAPaymentBank": "Select a payment bank",
  "devUpdates.addInstallment": "Add installment",
  "devUpdates.onlyOneInstallmentCanBeAddedAtATime":
    "Only one installment can be added at a time",
  "devUpdates.orderTotal": "Order total",
  "devUpdates.orderTotalPaid": "Order total paid",
  "devUpdates.receivingAccount": "Receiving account",
  "devUpdates.syncAttachments": "Sync attachments",
  "devUpdates.paymentMethodAttachments": "Payment method attachments",
  "devUpdates.paymentMethodNotes": "Payment method notes",
  "devUpdates.enterPaymentMethodNotes": "Enter payment method notes",
  "devUpdates.orderNumber": "Order number:",
  "devUpdates.installmentAmountDue": "Installment amount due",
  "devUpdates.approve": "Approve",
  "devUpdates.submitPaymentReceipt": "Submit payment receipt",
  "devUpdates.confirmPaymentReceipt": "Confirm payment receipt",
  "devUpdates.selectPaymentDate": "Select payment date",
  "devUpdates.selectOrderingCompany": "Select ordering company",
  "devUpdates.enterACompanyNameToSearch": "Enter a company name to search",
  "devUpdates.searching": "Searching...",
  "devUpdates.matchingCompanyListEmpty": "No matching companies",
  "devUpdates.selectPaymentBank": "Select payment bank",
  "devUpdates.noPaymentBanks": "No payment banks",
  "devUpdates.rejectPaymentMethod": "Reject payment method",
  "devUpdates.poster": "Poster",
  "devUpdates.passwordlessLogin": "Passwordless login",
  "devUpdates.wechatQrCode": "WeChat QR code",
  "devUpdates.scanWithWechatToLogInOrSignUp":
    "Scan with WeChat to log in or sign up",
  "devUpdates.byLoggingInOrSigningUpYouAgreeTo":
    "By logging in or signing up, you agree to",
  "devUpdates.and": "and",
  "devUpdates.orderAmount": "Order amount:",
  "devUpdates.created": "Created:",
  "devUpdates.tradeDetailsAreIncomplete": "Trade details are incomplete",
  "devUpdates.type": "Type:",
  "devUpdates.noContent": "No content",
  "devUpdates.remaining": "Remaining",
  "devUpdates.inspectionWorkflow": "Inspection workflow",
  "devUpdates.businessInspection": "Business inspection",
  "devUpdates.supervisorConfirmation": "Supervisor confirmation",
  "devUpdates.inspectionCompleted": "Inspection completed",
  "devUpdates.productDirectory": "Product directory",
  "devUpdates.products": "products",
  "devUpdates.batchActions": "Batch actions",
  "devUpdates.rejectionReason": "Rejection reason:",
  "devUpdates.failedToLoadInspectionInformation":
    "Failed to load inspection information",
  "devUpdates.quantityNotReceived": "Quantity not received",
  "devUpdates.quantityReceived": "Quantity received",
  "devUpdates.warehouseReceiptDetails": "Warehouse receipt details",
  "devUpdates.addWarehouseReceipt": "Add warehouse receipt",
  "devUpdates.syncOtherProducts": "Sync other products",
  "devUpdates.warehouseReceiptDate": "Warehouse receipt date",
  "devUpdates.warehouseReceiptNumber": "Warehouse receipt number",
  "devUpdates.enterTheWarehouseReceiptNumber":
    "Enter the warehouse receipt number",
  "devUpdates.actualQuantity": "Actual quantity",
  "devUpdates.deleteWarehouseReceipt": "Delete warehouse receipt",
  "devUpdates.inspectionDocuments": "Inspection documents",
  "devUpdates.uploading": "Uploading",
  "devUpdates.unopenedProductDetails": "Unopened product details",
  "devUpdates.unopenedPackaging": "Unopened packaging",
  "devUpdates.photos": "photos ·",
  "devUpdates.openedProductDetails": "Opened product details",
  "devUpdates.additionalInspectionTerms": "Additional inspection terms",
  "devUpdates.enterAdditionalInspectionTerms":
    "Enter additional inspection terms",
  "devUpdates.approvalNotes": "Approval notes",
  "devUpdates.loadingInspectionInformation": "Loading inspection information",
  "devUpdates.enterRejectionReason": "Enter rejection reason",
  "devUpdates.enterTheReason": "Enter the reason",
  "devUpdates.confirmRejection": "Confirm rejection",
  "devUpdates.enterTheSupplierName": "Enter the supplier name",
  "devUpdates.add": "Add",
  "devUpdates.filterByLinkedBank": "Filter by linked bank",
  "devUpdates.allBanks": "All banks",
  "devUpdates.suppliers": "Suppliers",
  "devUpdates.resetFilters": "Reset filters",
  "devUpdates.parentCompanyName": "Parent company name",
  "devUpdates.contactInformation": "Contact information",
  "devUpdates.supplierBankDetails": "Supplier bank details",
  "devUpdates.accounts": "accounts",
  "devUpdates.subsidiaryName": "Subsidiary name",
  "devUpdates.businessRegistrationCertificate":
    "Business registration certificate",
  "devUpdates.auditReport": "Audit report",
  "devUpdates.purchaseAgreement": "Purchase agreement",
  "devUpdates.questionnaire": "Questionnaire",
  "devUpdates.profileCreatedLabel": "Profile created:",
  "devUpdates.expires": "Expires:",
  "devUpdates.noSuppliers": "No suppliers",
  "devUpdates.addSupplier": "Add supplier",
  "devUpdates.supplierActions": "Supplier actions",
  "devUpdates.addBank": "Add bank",
  "devUpdates.addAddress": "Add address",
  "devUpdates.changeAddress": "Change address",
  "devUpdates.deleteSupplier": "Delete supplier",
  "devUpdates.supplierDetails": "Supplier details",
  "devUpdates.documentFiles": "Documents",
  "devUpdates.contactDetails": "Contact details",
  "devUpdates.bankName": "Bank name",
  "devUpdates.noSupplierBankDetails": "No supplier bank details",
  "devUpdates.noLinkedBanks": "No linked banks",
  "devUpdates.subsidiaryInformation": "Subsidiary information",
  "devUpdates.tradeStatus": "Trade status",
  "devUpdates.noSubsidiaries": "No subsidiaries",
  "devUpdates.selectOurBankAccountsAvailableToThisSupplier":
    "Select our bank accounts available to this supplier",
  "devUpdates.bankAccountLinkOptionsEmpty":
    "No bank accounts available to link",
  "devUpdates.saveLinkedAccounts": "Save linked accounts",
  "devUpdates.selectBank": "Select bank",
  "devUpdates.noBankDetailsForThisCompany": "No bank details for this company",
  "devUpdates.publishBidding": "Publish bidding",
  "devUpdates.backToBidding": "Back to bidding",
  "devUpdates.batchUpload": "Batch upload",
  "devUpdates.privacyProtection": "Privacy protection",
  "devUpdates.createCompanyProfileAction": "+ New company profile",
  "devUpdates.enterTheReceivingAccountNumber":
    "Enter the receiving account number",
  "devUpdates.publisher": "Publisher",
  "devUpdates.selectABusinessTeamMember": "Select a business team member",
  "devUpdates.selectAWeekIn2026": "Select a week in 2026",
  "devUpdates.selectStatus": "Select status",
  "devUpdates.productLocation": "Product location",
  "devUpdates.selectRegion": "Select region",
  "devUpdates.factorySealed": "Factory sealed",
  "devUpdates.other": "Other",
  "devUpdates.enterNotes": "Enter notes",
  "devUpdates.details": "Details",
  "devUpdates.productIdLink": "Product ID / link",
  "devUpdates.enterTheProductIdOrLink": "Enter the product ID or link",
  "devUpdates.specificationDatasheet": "Specification / datasheet",
  "devUpdates.uploadExcelFilesInBulk": "Upload Excel files in bulk",
  "devUpdates.dropAnExcelFileHereOr": "Drop an Excel file here, or",
  "devUpdates.supportsXlsxAndXls": "Supports .xlsx and .xls",
  "devUpdates.parsed": "Parsed",
  "devUpdates.records": "records",
  "devUpdates.remainingPrefix": "and",
  "devUpdates.moreRecords": "more records...",
  "devUpdates.bidLot": "Bid lot",
  "devUpdates.code": "Code",
  "devUpdates.enterTheCode": "Enter the code",
  "devUpdates.selectProductCategory": "Select product category",
  "devUpdates.enterCapacity": "Enter capacity",
  "devUpdates.selectPackage": "Select package",
  "devUpdates.selectTechnology": "Select technology",
  "devUpdates.enterStockQuantity": "Enter stock quantity",
  "devUpdates.packagingSelection": "Select packaging",
  "devUpdates.duplicateProductBindingNotAllowed":
    "This product is already linked",
  "devUpdates.pleaseFirstPrefix": "Please",
  "devUpdates.beforeLinkingTheProduct": "before linking the product",
  "devUpdates.published": "Published:",
  "devUpdates.publishSupplyDemand": "Publish supply / demand",
  "devUpdates.registerABrand": "Register a brand",
  "devUpdates.view": "View:",
  "devUpdates.brandCategory": "Brand category:",
  "devUpdates.region": "Region:",
  "devUpdates.sort": "Sort:",
  "devUpdates.productCount": "Products",
  "devUpdates.popularity": "Popularity",
  "devUpdates.founded": "Founded",
  "devUpdates.companyCount": "Companies",
  "devUpdates.orders": "Orders",
  "devUpdates.viewProducts": "View products",
  "devUpdates.brandName": "Brand name",
  "devUpdates.brandIntroduction": "Brand introduction",
  "devUpdates.active": "Active",
  "devUpdates.noMatchingBrands": "No matching brands",
  "devUpdates.productDetails": "Product details",
  "devUpdates.addDifferentBrandsPartNumbersQuantitiesAndUnitPrices":
    "Add different brands, part numbers, quantities and unit prices",
  "devUpdates.addProduct": "Add product",
  "devUpdates.unitPrice": "Unit price:",
  "devUpdates.noOrderAttachments": "No order attachments",
  "devUpdates.contractApprovalInformation": "Contract approval information",
  "devUpdates.contractApprovalOverview": "Contract approval information",
  "devUpdates.completePaymentReviewerAndContractFileInformation":
    "Complete payment, reviewer and contract file information",
  "devUpdates.approvalAndRelatedContent": "Approval and related content",
  "devUpdates.removeReviewer": "Remove reviewer",
  "devUpdates.contractFiles": "Contract files",
  "devUpdates.downloadContractTemplateAction": "Download contract template",
  "devUpdates.generatePoPurchaseContract": "Generate PO purchase contract",
  "devUpdates.moreSalesOrderInformation": "More sales order information",
  "devUpdates.buyerType": "Buyer type",
  "devUpdates.recipientPhoneNumber": "Recipient phone number",
  "devUpdates.totalPrice": "Total price",
  "devUpdates.moreDocuments": "More documents",
  "devUpdates.viewSpecification": "View specification",
  "devUpdates.enter": "Enter",
  "devUpdates.aNameToSearchAndAdd": "a name to search and add",
  "devUpdates.noSearchResults": "No search results",
  "devUpdates.buyerAndSellerInformation": "Buyer and seller information",
  "devUpdates.checkTradingPartiesBankDetailsAndPaymentAttachments":
    "Check trading parties, bank details and payment attachments",
  "devUpdates.paymentDocuments": "Payment documents",
  "devUpdates.viewTradeContractsAndUploadDocumentsRequiredForPayment":
    "View trade contracts and upload documents required for payment",
  "devUpdates.tradeContractPo": "Trade contract (PO)",
  "devUpdates.productAndPurchaseInformation":
    "Product and purchase information",
  "devUpdates.confirmTheProviderNegotiatorAndPurchaseProducts":
    "Confirm the provider, negotiator and purchase products",
  "devUpdates.selectAProductProvider": "Select a product provider",
  "devUpdates.completeProductTradeFieldsArrangedInFourColumns":
    "Complete product trade fields arranged in four columns",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeAndNotes":
    "Confirm contract number, delivery date, order type and notes",
  "devUpdates.enterTheContractNumber": "Enter the contract number",
  "devUpdates.completeSellerCompanyContactAddressAndBankDetails":
    "Complete seller company, contact, address and bank details",
  "devUpdates.showHiddenInformation": "Show additional information",
  "devUpdates.sellerCompanyTaxIdRequired": "Enter the seller tax ID",
  "devUpdates.enterTheBankName": "Enter the bank name",
  "devUpdates.swiftCodeRequired": "Enter the SWIFT code",
  "devUpdates.bankCodeRequired": "Enter the bank code",
  "devUpdates.bankEnglishAddressRequired": "Enter the bank address in English",
  "devUpdates.completeBuyerCompanyContactAndShippingDetails":
    "Complete buyer company, contact and shipping details",
  "devUpdates.buyerCompanyTaxIdRequired": "Enter the buyer tax ID",
  "devUpdates.addNotesForThisPurchaseOrderRequest":
    "Add notes for this purchase order request",
  "devUpdates.confirmInformationRequestAPurchaseQuoteThenGenerateTheOrder":
    "Confirm information, request a purchase quote, then generate the order",
  "devUpdates.piProFormaInvoice": "PI (pro forma invoice)",
  "devUpdates.ciCommercialInvoice": "CI (commercial invoice)",
  "devUpdates.quantity": "Quantity (",
  "devUpdates.selectOrdersForTheSameBuyerToMergeIntoASalesOrder":
    "Select orders for the same buyer to merge into a sales order",
  "devUpdates.editSalesProductsPricesQuantitiesDeliveryRegionsAndConditions":
    "Edit sales products, prices, quantities, delivery regions and conditions",
  "devUpdates.enterTheUnit": "Enter the unit",
  "devUpdates.orderDocuments": "Order documents",
  "devUpdates.currentOrder": "Current order:",
  "devUpdates.uploaded": "Uploaded",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeNegotiatorAfterSalesTermsAndPaymentMethod":
    "Confirm contract number, delivery date, order type, negotiator, after-sales terms and payment method",
  "devUpdates.addNotesForThisSalesOrderRequest":
    "Add notes for this sales order request",
  "devUpdates.thePurchasingTeamCanGenerateASalesOrderAfterRequestingAQuote":
    "The purchasing team can generate a sales order after requesting a quote",
  "devUpdates.orderContractInformation": "Order / contract information",
  "devUpdates.tradingParties": "Trading parties",
  "devUpdates.showTradingParties": "Show trading parties",
  "devUpdates.payInFull": "Pay in full",
  "devUpdates.payInInstallments": "Pay in installments",
  "devUpdates.completeOrderAfterFullPayment":
    "Complete order after full payment",
  "devUpdates.enterTheOrderingCompanyToSearch":
    "Enter the ordering company to search",
  "devUpdates.reviewNumber": "Review number",
  "devUpdates.partNumbersInThisReview": "Part numbers in this review",
  "devUpdates.totalStock": "Total stock",
  "devUpdates.partNumberCount": "Part number count",
  "devUpdates.selectedParticipants": "Selected participants",
  "devUpdates.totalQuantity": "Total quantity",
  "devUpdates.settlementAmount": "Settlement amount",
  "devUpdates.biddingRules": "Bidding rules",
  "devUpdates.publicationStatus": "Publication status",
  "devUpdates.commissionMethod": "Commission method",
  "devUpdates.commissionRate": "Commission rate",
  "devUpdates.participationLevel": "Participation level",
  "devUpdates.publishingCompany": "Publishing company",
  "devUpdates.submissionMethod": "Submission method",
  "devUpdates.publicationNotes": "Publication notes",
  "devUpdates.partNumberInformation": "Part number information",
  "devUpdates.productAttributes": "Product attributes",
  "devUpdates.stockAndPackaging": "Stock and packaging",
  "devUpdates.locationAndCondition": "Location and condition",
  "devUpdates.loadingMoreReviewDetails": "Loading more review details",
  "devUpdates.backToTop": "Back to top",
  "devUpdates.perPage": "Per page",
  "devUpdates.productLocationLabel": "Product location:",
  "devUpdates.packaging": "Packaging:",
  "devUpdates.stock": "Stock:",
  "devUpdates.selectedParticipantsLabel": "Selected participants:",
  "devUpdates.submitted": "Submitted:",
  "devUpdates.selectedBidders": "Selected bidders",
  "devUpdates.confirmedMinimumPrice": "Confirmed minimum price:",
  "devUpdates.totalQuantityLabel": "Total quantity:",
  "devUpdates.feeMethod": "Fee method:",
  "devUpdates.reviewWorkflow": "Review workflow",
  "devUpdates.enterReviewNotes": "Enter review notes",
  "devUpdates.loadingReviewDetails": "Loading review details",
  "devUpdates.reviewNotFound": "Review not found",
  "devUpdates.backToReviews": "Back to reviews",
  "devUpdates.pleaseCheckAll": "Please check all",
  "devUpdates.informationBeforeConfirmingTheReview":
    "information before confirming the review",
  "devUpdates.productSpecifications": "Product specifications",
  "devUpdates.pagePath": "Page path",
  "devUpdates.inspectionProgress": "Inspection progress",
  "devUpdates.productInformationAndWarehouseReceipts":
    "Product information and warehouse receipts",
  "devUpdates.automaticallyTotaled": "· Automatically totaled",
  "devUpdates.applyToAll": "Apply to all",
  "devUpdates.enterTheActualQuantity": "Enter the actual quantity",
  "devUpdates.videos": "· videos",
  "devUpdates.noVideos": "No videos",
  "devUpdates.additionalInspectionTermsRequired":
    "Enter additional inspection terms",
  "devUpdates.enterSpecificRejectionReason": "Enter the rejection reason",
  "devUpdates.manageSupplierProfilesContactsBanksAndAddresses":
    "Manage supplier profiles, contacts, banks and addresses",
  "devUpdates.selectLinkedBankAccounts": "Select linked bank accounts",
  "devUpdates.purchaseFrameworkAgreement": "Purchase framework agreement",
  "devUpdates.copySupplierBankDetails": "Copy supplier bank details",
  "devUpdates.subsidiaryDetails": "Subsidiary details",
  "devUpdates.expiryDate": "Expiry date",
  "devUpdates.ourLinkedBankAccounts": "Our linked bank accounts",
  "devUpdates.profileCreated": "Profile created",
  "devUpdates.supplierQuestionnaire": "Supplier questionnaire",
  "devUpdates.createAddress": "Add address",
  "devUpdates.bankLogo": "Bank logo",
  "devUpdates.subsidiaries": "subsidiaries",
  "devUpdates.bankAccounts": "bank accounts",
  "devUpdates.companyCodePlaceholder": "Enter the company code",
  "devUpdates.legalRepresentativePlaceholder": "Enter the legal representative",
  "devUpdates.companyContact": "Company contact",
  "devUpdates.enterTheCompanyContact": "Enter the company contact",
  "devUpdates.enterContactDetails": "Enter contact details",
  "devUpdates.fullAddress": "Full address",
  "devUpdates.fullAddressPlaceholder": "Enter the full address",
  "devUpdates.bankNamePlaceholder": "Enter the bank name",
  "devUpdates.receivingAccountPlaceholder":
    "Enter the receiving account number",
  "devUpdates.bankAccountNumber": "Bank account number",
  "devUpdates.bankAccountPlaceholder": "Enter the bank account number",
  "devUpdates.bankAddress": "Bank address",
  "devUpdates.enterTheBankAddress": "Enter the bank address",
  "devUpdates.swiftCodePlaceholder": "Enter the SWIFT code",
  "devUpdates.bankCodePlaceholder": "Enter the bank code",
  "devUpdates.notesPlaceholder": "Enter notes",
  "devUpdates.confirm": "Confirm",
  "devUpdates.cancel": "Cancel",
  "devUpdates.onlineInquiry": "Online inquiry",
  "devUpdates.selectSpecifications": "Select specifications",
  "devUpdates.remainingStock": "Remaining stock:",
  "devUpdates.smartSearchResults": "” smart search results",
  "devUpdates.generatedLiveByXsouAiVerifyKeyParametersAgainstTheProductDatasheet":
    "Generated live by XSOU AI. Verify key parameters against the product datasheet.",
  "devUpdates.found": "Found",
  "devUpdates.resultsFor": "results for “",
  "devUpdates.relatedSearchClosingQuote": "”",
  "devUpdates.results": "results",
  "devUpdates.wikiContentIsBeingGeneratedAndWillAppearWhenReady":
    "Wiki content is being generated and will appear when ready.",
  "devUpdates.answers": "answers",
  "devUpdates.viewAllQA": "View all Q&A",
  "devUpdates.closeEnlargedImage": "Close enlarged image",
  "devUpdates.chipWikiEntryNotFound": "Chip wiki entry not found",
  "devUpdates.backToChipWiki": "Back to chip wiki",
  "devUpdates.generatedLiveByXsouAi": "Generated live by XSOU AI",
});

// 通用业务用语
export const business = Object.freeze({
  "business.goodsCenter": "Product Center",
  "business.goodsCenterDescription": "View and manage published products",
  "business.publishedGoods": "Published Products",
  "business.searchAll": "Search All",
  "business.searchName": "Search by Name",
  "business.searchPartNumber": "Search by Part Number",
  "business.searchSuffix": "Search",
  "business.nameAndPartNumber": "Name or Part Number",
  "business.name": "Name",
  "business.partNumber": "Part Number",
  "business.viewDetails": "View Details",
  "business.editGoods": "Edit Product Information",
  "business.editBuyerPhone": "Edit Buyer Mobile",
  "business.editSaleRange": "Edit Sales Availability",
  "business.inviteBuyerLink": "Buyer Invitation Link",
  "business.noGoods": "No products yet",
  "business.noMoreGoods": "No more products",
  "business.loading": "Loading...",
  "business.price": "Price",
  "business.enterPrice": "Enter a price",
  "business.cny": "CNY",
  "business.usd": "USD",
  "business.quantity": "Quantity",
  "business.enterQuantity": "Enter a quantity",
  "business.validUntil": "Valid Until",
  "business.selectValidUntil": "Select an expiration date",
  "business.submitChanges": "Save Changes",
  "business.editBuyerMobile": "Edit Buyer Mobile",
  "business.buyerMobile": "Buyer Mobile",
  "business.addMobile": "Add Mobile",
  "business.enterMobile": "Enter a mobile number",
  "business.set": "Set",
  "business.add": "Add",
  "business.currentBuyerMobile": "Current Buyer Mobile",
  "business.addedMobile": "Added Mobile Numbers",
  "business.noMobile": "No mobile number yet",
  "business.cancel": "Cancel",
  "business.confirmChanges": "Confirm Changes",
  "business.confirmAdd": "Confirm Addition",
  "business.purchaseBusiness": "Purchasing Staff",
  "business.purchaseNegotiator": "Purchasing Negotiator",
  "business.mobileAlreadyExists": "This mobile number already exists",
  "business.onlyOneMobile":
    "Only one mobile number can be added for this product",
  "business.changesSaved": "Changes saved",
  "business.changesFailed": "Failed to save changes",
  "business.copySuccess": "Copied",
  "business.copyFailed": "Copy failed",
  "business.oneChangeRequired": "Enter a price, quantity or expiration date",
  "business.retryChanges": "Failed to save changes. Please try again later",
  "business.goodsLoadFailed": "Failed to load products",
  "business.retryGoodsLoad": "Failed to load products. Please try again later",
  "business.sellerTitle": "I Am a Seller",
  "business.image": "Image",
  "business.productName": "Product Name",
  "business.specPartNumber": "Specification / Part Number",
  "business.totalQuantity": "Total Quantity",
  "business.remainingQuantity": "Remaining",
  "business.negotiator": "Negotiator",
  "business.contact": "Contact",
  "business.publishedAt": "Published At",
  "business.action": "Action",
  "business.myInfo": "My Listings",
  "business.clueType": "Lead Type",
  "business.selectType": "Select a type",
  "business.title": "Title",
  "business.brand": "Brand",
  "business.unitPrice": "Unit Price",
  "business.seller": "Seller",
  "business.wechat": "WeChat",
  "business.mobile": "Mobile",
  "business.clueStatus": "Listing Status",
  "business.time": "Time",
  "business.draft": "Draft",
  "business.pendingReview": "Pending Review",
  "business.reviewed": "Reviewed",
  "business.published": "Published",
  "business.ended": "Ended",
  "business.supplyInfo": "Supply Lead",
  "business.buyRequestInfo": "Buy Request",
  "business.all": "All",
  "business.supply": "Supply",
  "business.buyRequest": "Buy Request",
  "business.myClues": "My Published Leads",
  "business.noData": "No data yet",
  "business.noMore": "You've reached the end",
  "business.currentStatus": "Current Status",
  "business.completeInfo": "Complete Information",
  "business.details": "Details",
  "business.mySalesGoods": "My Products for Sale",
  "business.biddingManagement": "Bid Management",
  "business.biddingList": "Bid List",
  "business.bidExport.selectFirst": "Select bids to export first",
  "business.bidExport.priceColumn": "Bid Price",
  "business.bidExport.totalColumn": "Total Amount",
  "business.bidExport.remarkColumn": "Remarks",
  "business.bidExport.filePrefix": "Bid_Order",
  "business.bidExport.success": "Exported {count} bids",
  "business.bidExport.failed": "Export failed. Please try again",
  "business.searchBidding": "Search part number, brand or ID",
  "business.card": "Cards",
  "business.list": "List",
  "business.customerName": "Customer Name",
  "business.bidQuantity": "Bid Quantity",
  "business.bidPrice": "Bid Price",
  "business.view": "View",
  "business.noBidding": "No bids yet",
  "business.bidNumber": "ID",
  "business.period": "Round",
  "business.type": "Type",
  "business.status": "Status",
  "business.biddingTime": "Bid Time",
  "business.noMoreBidding": "No more bids",
  "business.publishBid": "Publish Bid",
  "business.searchPublishedBid": "Search part number, brand or ID...",
  "business.referencePrice": "Reference Price",
  "business.edit": "Edit",
  "business.delete": "Delete",
  "business.noPublishedBid": "No published bids yet",
  "business.myBids": "My Bids",
  "business.viewToggle": "View Switcher",
  "business.cardView": "Card View",
  "business.listView": "List View",
  "business.switchCardView": "Switch to card view",
  "business.switchListView": "Switch to list view",
  "business.searchBidProject": "Search bids",
  "business.allBids": "All",
  "business.openBids": "Open",
  "business.closedBids": "Closed",
  "business.openedBids": "Opened",
  "business.wonBids": "Won",
  "business.lostBids": "Lost",
  "business.productCategory": "Product Category",
  "business.technology": "Technology",
  "business.capacity": "Capacity",
  "business.bidUnitPrice": "Unit Bid Price",
  "business.editBid": "Edit Bid",
  "business.editOnlyOpen": "Only open bids can be edited",
  "business.statusAndId": "Status / ID",
  "business.productInfo": "Product Information",
  "business.goodsInfo": "Goods Information",
  "business.timeInfo": "Time Information",
  "business.bidInfo": "Bid Information",
  "business.location": "Location",
  "business.packaging": "Packaging",
  "business.package": "Package",
  "business.bidDeadline": "Bid Deadline",
  "business.bidOpen": "Bid Opening",
  "business.level": "Level",
  "business.participants": "Participants",
  "business.bidDialog.viewDetails": "View details",
  "business.bidDialog.favorite": "Save bid",
  "business.bidDialog.share": "Share bid",
  "business.bidDialog.basicInfo": "Basic information",
  "business.bidDialog.stockLocation": "Stock location",
  "business.bidDialog.stock": "Stock",
  "business.bidDialog.currency": "Currency",
  "business.bidDialog.referenceUnitPrice": "Reference unit price",
  "business.bidDialog.quoteInfo": "Bid information",
  "business.bidDialog.myQuote": "My bid",
  "business.bidDialog.enterQuote": "Enter your bid",
  "business.bidDialog.requiredQuantity": "Required quantity",
  "business.bidDialog.maximum": "Maximum: {count}",
  "business.bidDialog.submit": "Submit bid",
  "business.bidDialog.history": "Bid history",
  "business.bidDialog.noHistory": "No bid history yet",
  "business.bidDialog.quote": "Bid",
  "business.bidDialog.totalPrice": "Total goods price",
  "business.bidDialog.commission": "Commission ({percent}% · {mode})",
  "business.bidDialog.commissionLabel": "Commission",
  "business.bidDialog.payable": "Payable",
  "business.bidDialog.deducted": "Deducted",
  "business.bidDialog.added": "Added",
});

export const sharedUi = Object.freeze({
  "sharedUi.partNumberPrefix": "Part number: ",
  "sharedUi.added": "Added",
  "sharedUi.item": "Item",
  "sharedUi.editSucceeded": "Changes saved",
  "sharedUi.completeRequired": "Check and complete the required fields",
  "sharedUi.confirmationFailed": "Unable to confirm",
  "sharedUi.skipLogin": "Not now",
  "sharedUi.closeDialog": "Close {title} dialog",
  "sharedUi.closeDetails": "Close {title}",
});

export const sharedFlowUi = Object.freeze({
  "sharedUi.required": "Required",
  "sharedUi.optional": "Optional",
});

export const messages = Object.freeze({
"loginBindings.bindTitle": "Link {account}",
"loginBindings.bind": "Link account",
"loginBindings.scan": "Scan with WeChat to link your account",
"loginBindings.country": "Country code",
"loginBindings.code": "Verification code",
"loginBindings.send": "Send code",
"loginBindings.confirm": "Confirm link",

"loginBindings.title": "Login bindings",
"loginBindings.phone": "Phone",
"loginBindings.email": "Email",
"loginBindings.wechat": "WeChat",
"loginBindings.wecom": "WeCom",
"loginBindings.google": "Google",
"loginBindings.bound": "Linked",
"loginBindings.unbound": "Not linked",
"loginBindings.failed": "Unable to load login bindings",
"loginBindings.retry": "Retry",

  "passwordReset.title": "Forgot password",
  "passwordReset.account": "Phone number / email",
  "passwordReset.code": "Verification code",
  "passwordReset.send": "Send code",
  "passwordReset.resend": "Resend in {seconds}s",
  "passwordReset.password": "New password (8–20 characters)",
  "passwordReset.confirmPassword": "Confirm new password",
  "passwordReset.submit": "Reset password",
  "passwordReset.saving": "Submitting",
  "passwordReset.invalidAccount": "Enter a valid phone number or email address",
  "passwordReset.invalidCode": "Enter the 4-digit verification code",
  "passwordReset.passwordLength": "Password must contain 8–20 characters",
  "passwordReset.mismatch": "The passwords do not match",
  "passwordReset.sent": "Verification code sent",
  "passwordReset.success": "Password reset. Sign in with your new password.",
  "passwordReset.failed": "Unable to complete the request. Please try again later.",
  "authnMerge.regions": "SMS verification for real-name authentication currently supports mainland China and Hong Kong, China. Other regions will be added later.",
  "authnMerge.notice": "Verify with your own phone number. If it already belongs to an account, submitting will merge your sign-in identity into that account and switch accounts. Conflicting identity or authentication details will not be overwritten.",
"passwordReset.phone": "Phone number",
"passwordReset.email": "Email",
"passwordReset.smsCode": "SMS verification code",
"passwordReset.emailCode": "Email verification code",

  "recentFlow.receiptFailure": "Unable to complete the receipt action. Please try again.",
  "recentFlow.batchInvalid": "Invalid shipment batch data. Please try again.",
  "recentFlow.historyFailure": "Unable to load shipment history. Please try again.",
  "recentFlow.supplierQuantityInvalid": "A valid product order ID and positive integer quantity are required.",
  "recentFlow.outboundQuantityInvalid": "Order and outbound detail IDs must be valid and quantities positive integers. Reload outbound orders.",
  "recentFlow.uploadPending": "Wait until the shipping documents finish uploading before submitting.",

  "recentFlow.name": "Product name",
  "recentFlow.brand": "Brand",
  "recentFlow.model": "Part number",
  "recentFlow.price": "Price",
  "recentFlow.quantity": "Quantity",
  "recentFlow.code": "Product code",
  "recentFlow.placed": "Order placed",
  "recentFlow.processing": "Order processing",
  "recentFlow.completed": "Completed",
  "recentFlow.purchase": "Purchase",
  "recentFlow.sales": "Sales",

  "recentFlow.confirm": "Confirm receipt",
  "recentFlow.orderNumber": "Order number: ",
  "recentFlow.hint": "Check the shipment details and quantities, then confirm each batch received.",
  "recentFlow.loading": "Loading shipments…",
  "recentFlow.reload": "Reload",
  "recentFlow.empty": "No shipment batches",
  "recentFlow.received": "Received",
  "recentFlow.waiting": "Awaiting receipt",
  "recentFlow.shippedAt": "Shipped at",
  "recentFlow.company": "Carrier",
  "recentFlow.tracking": "Tracking number",
  "recentFlow.remark": "Shipping note",
  "recentFlow.receivedAt": "Received at",
  "recentFlow.modelMissing": "Model not specified",
  "recentFlow.unit": "items",
  "recentFlow.voucher": "Shipping documents",
  "recentFlow.close": "Close",
  "recentFlow.loadFailed": "Unable to load shipments. Please try again.",
  "recentFlow.resultInvalid": "Unexpected receipt result. Reload to verify.",
  "recentFlow.success": "Receipt confirmed for this batch.",
  "recentFlow.failed": "Unable to confirm receipt. Please try again.",
  "recentFlow.submitting": "Submitting",
  "recentFlow.submitSettlement": "Submit settlement",
  "recentFlow.ordersLoading": "Loading orders",
  "recentFlow.ordersEmpty": "No related orders",
  "recentFlow.ordersFailed": "Unable to load related orders.",
  "recentFlow.specFailed": "Unable to load product specifications.",
  "recentFlow.splitFailed": "Unable to split the product.",
  "recentFlow.wholeSuccess": "Whole product conversion completed.",
  "recentFlow.splitSuccess": "Product split completed.",
  "recentFlow.splitRetry": "Unable to split the product. Please try again later.",
  "recentFlow.confirmWhole": "Confirm whole product",
  "recentFlow.confirmSplit": "Confirm split",
  "recentFlow.wholeHint": "Adjust specification prices and enter the buyer phone number to submit.",
  "recentFlow.splitHint": "Enter the buyer phone number, select specifications, and confirm prices and quantities.",
  "recentFlow.batchTitle": "Shipment batch {count}",
  "recentFlow.specifications": "specifications",

  "bulkShipping.uploadFailed": "Unable to upload shipping information. Please try again later.",
  "mobilePublish.itemTitle": "Item {count}",
  "mobilePublish.copy": "Copy",
  "mobilePublish.remove": "Delete",
  "mobilePublish.addItem": "Add item",
  "mobileQuickOrder.waitForGoods": "Please wait for the product information to load and try again.",
  "mobileQuickOrder.detailsFailed": "Unable to load item details. Please refresh and try again.",
  "mobileQuickOrder.specificationsChanged": "Product specifications have changed. Return to the product details and select again.",

  ...sharedFlowUi,
  ...sharedUi,
  ...base,
  ...merged20261021,
  ...formDisplay,
  ...catalogDisplay,
  ...systemFeedback,
  ...business,
});

// 语言菜单使用各语言自称，不随当前界面语言更改。
export const languageNames = Object.freeze({
  "zh-CN": "简体中文",
  "zh-HK": "繁體中文（香港）",
  "en-US": "English",
});
